import { formatCurrency, getCurrencySymbol } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, LOCALE_ID, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTabGroup } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { ListaPrecoTabelaService } from '../../../../../shared/services/lista-preco-tabela.service';
import { Location } from '@angular/common';
import { Utils } from '../../../../../../app/utils/utils';
import * as FileSaver from 'file-saver';
import { BehaviorSubject, forkJoin, Observable, of, ReplaySubject, Subject, timer } from 'rxjs';
import { debounceTime, finalize, retry, share, switchMap, takeUntil, tap, filter, map, delay, catchError, take } from 'rxjs/operators';
import { Estados } from '../../../../../shared/inmemory-db/estados';
import { ModalidadeFrete } from '../../../../../shared/inmemory-db/modalidade-frete';
import { TipoCadastro } from '../../../../../shared/inmemory-db/tipo-cadastro';
import { Cadastro } from '../../../../../shared/interfaces/cadastro';
import { Condpg } from '../../../../../shared/interfaces/condpg';
import { Estado } from '../../../../../shared/interfaces/estado';
import { FatDoctoC } from '../../../../../shared/interfaces/fat-docto-c';
import { FatDoctoCCce } from '../../../../../shared/interfaces/fat-docto-cc-ce';
import { NFSE_SITUACAO_DESCRICAO } from '../../../../../shared/interfaces/fat-docto-c-nfse';
import { FatDoctoI, ItemID } from '../../../../../shared/interfaces/fat-docto-i';
import { FatSerie } from '../../../../../shared/interfaces/fat-serie';
import { ListaPreco } from '../../../../../shared/interfaces/lista-preco';
import { ListaPrecoTabela } from '../../../../../shared/interfaces/lista-preco-tabela';
import { Log } from '../../../../../shared/interfaces/log';
import { PageResult } from '../../../../../shared/interfaces/page-result';
import { Produto } from '../../../../../shared/interfaces/produto';
import { Transacao } from '../../../../../shared/interfaces/transacao';
import { AppConfirmService } from '../../../../../shared/services/app-confirm/app-confirm.service';
import { AppLoaderProgressService } from '../../../../../shared/services/app-loader-progress/app-loader-progress.service';
import { AppLoaderService } from '../../../../../shared/services/app-loader/app-loader.service';
import { CadastroService } from '../../../../../shared/services/cadastro.service';
import { CrmService } from '../../../../../shared/services/crm.service';
import { CadastroOcorrencia } from '../../../../../shared/interfaces/cadastro-ocorrencia';
import { CondpgService } from '../../../../../shared/services/condpg.service';
import { FatDoctoCService } from '../../../../../shared/services/fat-docto-c.service';
import { FatDoctoCUtilsService } from '../../../../../shared/services/fat-docto-c-utils.service';
import { ListaPrecoService } from '../../../../../shared/services/lista-preco.service';
import { ListaPrecoResolvida } from '../../../../../shared/interfaces/lista-preco-resolvida';
import { D134_OBRIGATORIO, D134_SOMENTE_AVISAR, divergenciaListaPrecoCliente, precoProdutoPorListaTabela } from '../../../../../shared/helpers/politica-lista-preco.helper';
import { ProdutoService } from '../../../../../shared/services/produto.service';
import { LotePublicacao, MercadoLivreAnuncioService } from 'app/shared/services/mercado-livre-anuncio.service';
import { SerieService } from '../../../../../shared/services/serie.service';
import { TransacaoService } from '../../../../../shared/services/transacao.service';
import { VeiculoService } from '../../../../../shared/services/veiculo.service';
import { Veiculo } from '../../../../../shared/interfaces/veiculo';
import { TxtAddService } from '../../../../../shared/services/txtAdd.service';
import { TxtAdd } from '../../../../../shared/interfaces/txtAdd';
import { CadastroTablePopupComponent } from '../../../../cadastro/cadastros/cadastro/cadastro-table-popup/cadastro-table-popup.component';
import { CondpgPopupComponent } from '../../../../cadastro/faturamento/condpg/condpg-popup/condpg-popup.component';
import { PrecoTablePopupComponent } from '../../../../cadastro/faturamento/preco-table/preco-table-popup/preco-table-popup.component';
import { LayoutService } from '../../../../../shared/services/layout.service';
import { LancamentoItensComponent } from '../lancamento-itens/lancamento-itens.component';
import { LancamentoTotaisComponent } from '../lancamento-totais/lancamento-totais.component';
import { LancamentoTranspComponent } from '../lancamento-transp/lancamento-transp.component';
import { LancamentoNfeComponent } from '../lancamento-nfe/lancamento-nfe.component';
import { LancamentoParcelasComponent } from '../lancamento-parcelas/lancamento-parcelas.component';
import { LancamentoReferComponent } from '../lancamento-refer/lancamento-refer.component';
import { LancamentoCCComponent } from '../lancamento-cc/lancamento-cc.component';
import { LancamentoAnexoUploadListComponent } from '../lancamento-anexo-upload-list/lancamento-anexo-upload-list.component';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { DateAdapter } from 'angular-calendar';
import { CadastroAnexoUploadListComponent } from '../../../../../views/cadastro/cadastros/cadastro/cadastro-anexo-upload-list/cadastro-anexo-upload-list.component';
import { WhatsappEditComponent } from '../../../../whatsapp-edit/whatsapp-edit.component';
import { extractBackendErrorMessage } from '../../../../../shared/helpers/backend-error-message';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-lancamento-details',
  templateUrl: 'lancamento-details.component.html',
  styleUrls: ['lancamento-details.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LancamentoDetailsComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator, { static: false }) paginatorItem: MatPaginator;
  @ViewChild('ngxDatatable') ngxDatatable: DatatableComponent;
  @ViewChild('cadCadastro') cadCadastroMatInput: ElementRef;
  @ViewChild('produtoSearch') produtoSearchInput: ElementRef;
  @ViewChild('previaMenuTrigger', { read: MatMenuTrigger }) previaMenuTrigger: MatMenuTrigger;

  lctoDetails = '';

  public doctoCForm: FormGroup;
  doctoIForm: FormGroup;
  public itemDiretivasFatForm: FormGroup;

  modalidadesFrete: any[];
  estados: Estado[];

  lcto: FatDoctoC;
  selectedTabIndex = 0;

  fatTransacoes: Transacao[] = [];
  filteredTransacoes: ReplaySubject<Transacao[]> = new ReplaySubject<Transacao[]>(1);
  fatTransacao: Transacao;
  isLoadingFatTransacao = false;

  produtos: Produto[];
  produtos$: BehaviorSubject<Produto[]> = new BehaviorSubject<Produto[]>(null);
  produto: Produto;
  isLoadingProduto = false;

  series: FatSerie[];
  serie: FatSerie;
  isLoadingSerie = false;

  doctoCs: FatDoctoC[];
  doctoC: FatDoctoC;
  isLoadingDoctoC = false;

  filteredDestinatarios: ReplaySubject<Cadastro[]> = new ReplaySubject<Cadastro[]>(1);
  destinatarios: Cadastro[] = [];
  destinatario: Cadastro;
  /** endereços do destinatário para escolher o de faturamento (vazio = só o do cadastro) */
  enderecosFaturamento: any[] = [];
  isLoadingDestinatario = false;

  vendedores: Cadastro[] = [];
  vendedor: Cadastro;
  isLoadingVendedor = false;

  // ---- Ordem de Serviço (mesma tela do lançamento, como no desktop ordemServico.fxml) ----
  veiculos: Veiculo[] = [];
  veiculo: Veiculo;
  isLoadingVeiculo = false;
  /** d122 da transação: 4 = Ordem de Serviço (TipoLcto.ORDEM_SERVICO no backend). */
  operacaoDiretiva: number = null;
  /** tipoLcto usado na criação (query param ?tipoLcto=ORDEM_SERVICO abre uma OS nova). */
  tipoLcto = 'LCTO';

  transps: Cadastro[];
  transp: Cadastro;
  isLoadingTransp = false;

  motoristas: Cadastro[];
  motorista: Cadastro;
  isLoadingMotorista = false;

  filteredCondpgs: ReplaySubject<Condpg[]> = new ReplaySubject<Condpg[]>(1);
  condPgs: Condpg[];
  condPg: Condpg;
  isLoadingCondPg = false;

  listaPrecos$: BehaviorSubject<ListaPreco[]> = new BehaviorSubject<ListaPreco[]>(null);
  listaPrecos: ListaPreco[] = [];
  listaPreco: ListaPreco;
  isLoadingPreco = false;

  tabelas$: BehaviorSubject<ListaPrecoTabela[]> = new BehaviorSubject<ListaPrecoTabela[]>(null);
  tabelas: ListaPrecoTabela[] = []
  tabela: ListaPrecoTabela;
  isLoadingTabela = false;

  pageObjectDoctoI$: BehaviorSubject<PageResult<FatDoctoI>> = new BehaviorSubject<PageResult<FatDoctoI>>(null);
  searchEntry$: Subject<string> = new Subject<string>();
  produtoItemExists$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  doctoIs: FatDoctoI[];
  doctoIs$: BehaviorSubject<FatDoctoI[]> = new BehaviorSubject<FatDoctoI[]>([]);
  doctoI: FatDoctoI;
  pageItem = 1;
  lengthItem = 0;
  pageSizeItem = 10;
  pageEventItem = null;
  pageSizeOptionsItem: number[] = [5, 10, 25];
  selectedItemOrdem = 'NENHUM';
  selectedItemDirect = 'ASC';
  public searchInput = '';

  mouseoverAutoriza = false;
  mouseoverCancela = false;
  mousepageObjectDoctoI$
  errorMsg: string;

  maskFone = {
    mask: '(00) {*}0000-0000',
    lazy: true,  // make placeholder always visible
    placeholderChar: '_'     // defaults to '_'
  };

  maskCep = {
    mask: '00000-000',
    lazy: true,  // make placeholder always visible
    placeholderChar: '_'     // defaults to '_'
  };

  maskCpf = {
    mask: '000.000.000-00',
    lazy: true,  // make placeholder always visible
    placeholderChar: '_'     // defaults to '_'
  };

  maskCnpj = {
    mask: 'SS.SSS.SSS/SSSS-00',
    definitions: { S: /[0-9A-Za-z]/ },
    prepare: (str: string) => (str || '').toUpperCase(),
    lazy: true,  // make placeholder always visible
    placeholderChar: '_'     // defaults to '_'
  };
  maskUpper = {
    mask: /^\w\s*/,
    prepare: (str: any) => str.toUpperCase()
  };
  maskLower = {
    mask: /^\w\s*/,
    prepare: (str: any) => str.toLowerCase()
  };

  maskEmail = {
    mask: /^\S*@?\S*$/,
    prepare: (email: any) => email.toLowerCase()
  };

  newItem = {} as FatDoctoI;

  isEditableDoctI = {};
  precoPadrao: any;

  controle: any;
  showEditOption: boolean;
  dfe: boolean;

  openModal = false;
  deniedInitData: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  utils = Utils;

  max = null;
  workDone = null;
  it = 0;
  maxRetry = 20;
  created = false;
  disabled: true;
  public layoutConf: any;
  public searching = false;
  protected _onDestroy = new Subject<void>();
  private stopPolling = new Subject();

  // ---- Lookup de Texto Padrão para Dados Adicionais (mesmo fluxo do envio de WhatsApp) ----
  showTxtAddLookup = false;
  txtAddResults: TxtAdd[] = [];
  txtAddSearch = '';
  txtAddLoading = false;
  txtAddTargetField: string | null = null;
  private txtAddSearch$ = new Subject<string>();
  private static readonly TXTADD_SEARCH_KEY = 'lancamento_txtadd_last_search';

  /**
   * Aberto a partir de um cartão do funil (/lcto_detail/add?cadastroId=&oportunidadeId=): o primeiro
   * salvamento liga este lançamento ao cartão. Zera depois de ligar, para não repetir a chamada.
   */
  private oportunidadeIdDoFunil: number | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    @Inject(LOCALE_ID) private locale: string,
    private fb: FormBuilder,
    private confirmService: AppConfirmService,
    private fatDoctoCService: FatDoctoCService,
    private fatDoctoCUtilsService: FatDoctoCUtilsService,
    private produtoService: ProdutoService,
    private cadastroService: CadastroService,
    private fatTransacaoService: TransacaoService,
    private veiculoService: VeiculoService,
    private serieService: SerieService,
    private condPgService: CondpgService,
    private precoService: ListaPrecoService,
    private mercadoLivreAnuncioService: MercadoLivreAnuncioService,
    private tabelaPrecoService: ListaPrecoTabelaService,
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private loader: AppLoaderService,
    private ref: ChangeDetectorRef,
    private progressLoader: AppLoaderProgressService,
    private renderer: Renderer2,
    private location: Location,
    private layout: LayoutService,
    private txtAddService: TxtAddService,
    private crmService: CrmService,
    @Optional() private currentDialogRef?: MatDialogRef<LancamentoDetailsComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) private dialogData?: any,
  ) {
    this.modalidadesFrete = new ModalidadeFrete().modalidades;
    this.estados = new Estados().estados;
  }

  openPreviasMenu(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    if (!this.previaMenuTrigger) {
      console.warn('previaMenuTrigger não inicializado');
      return;
    }
    try {
      this.previaMenuTrigger.openMenu();
    } catch (e) {
      console.error('Erro abrindo menu de prévia', e);
    }
  }



  /**
   * Abre/fecha o painel de texto padrão para um dos campos de Dados Adicionais.
   * field: 'dadosadicionais' | 'dadosadicionaiscontribuinte' | 'outrosDados'
   */
  toggleTxtAddLookup(field: string): void {
    // Se já estiver aberto para o mesmo campo, fecha (toggle). Se for outro campo, troca o alvo.
    if (this.showTxtAddLookup && this.txtAddTargetField === field) {
      this.showTxtAddLookup = false;
      return;
    }
    this.txtAddTargetField = field;
    this.showTxtAddLookup = true;
    const lastSearch = localStorage.getItem(LancamentoDetailsComponent.TXTADD_SEARCH_KEY) || '';
    if (lastSearch && !this.txtAddSearch) {
      this.txtAddSearch = lastSearch;
      this.txtAddSearch$.next(lastSearch);
    } else if (this.txtAddResults.length === 0) {
      this.loadTxtAddPage();
    }
  }

  onTxtAddSearchChange(term: string): void {
    this.txtAddSearch = term;
    this.txtAddSearch$.next(term);
  }

  loadTxtAddPage(): void {
    this.txtAddLoading = true;
    this.txtAddService.getTxtAddPage(1, 20).subscribe(
      (page: any) => {
        this.txtAddResults = page?.content || [];
        this.txtAddLoading = false;
      },
      () => this.txtAddLoading = false
    );
  }

  /** Aplica o texto selecionado ao campo alvo (concatena com quebra de linha se já houver conteúdo). */
  selectTxtAdd(item: TxtAdd): void {
    const field = this.txtAddTargetField;
    if (!field) {
      return;
    }
    const control = this.doctoCForm.get(field);
    if (!control) {
      return;
    }
    const current = control.value || '';
    const texto = item?.texto || '';
    control.setValue(current ? current + '\n' + texto : texto);
    control.markAsDirty();
    localStorage.setItem(LancamentoDetailsComponent.TXTADD_SEARCH_KEY, this.txtAddSearch);
    this.showTxtAddLookup = false;
  }

  ngOnInit() {
    this.layoutConf = this.layout.layoutConf;
    this.controle = this.route.snapshot.params['controle'];
    this.tipoLcto = (this.route.snapshot.queryParamMap.get('tipoLcto') || 'LCTO').toUpperCase();
    const oportunidadeId = Number(this.route.snapshot.queryParamMap.get('oportunidadeId'));
    this.oportunidadeIdDoFunil = oportunidadeId > 0 ? oportunidadeId : null;
    const dialogLcto = this.dialogData?.payload as FatDoctoC;
    this.openModal = (this.route.snapshot.params['openModal'] ?? false) || !!this.currentDialogRef || !!dialogLcto?.controle;
    this.buildDoctoCForm(null);
    if (dialogLcto?.controle > 0) {
      console.log('MODAL COM PAYLOAD E EDITANDO');
      this.lcto = dialogLcto;
      this.controle = dialogLcto.controle;
      this.buildDoctoCForm(dialogLcto);
      this.doctoCForm.patchValue({ items: this.fb.array([]) });
      this.reloadLctoDetails(dialogLcto);
      this.showEditOption = false;
    } else if (this.openModal && this.lcto?.controle > 0) {
      console.log('MODAL ABERTO E EDITANDO');
      this.controle = this.lcto?.controle;
      this.buildDoctoCForm(this.lcto);
      this.doctoCForm.patchValue({ items: this.fb.array([]) });
      this.reloadLctoDetails(this.lcto);
      this.showEditOption = false;
    } else {
      if (this.controle) {
        console.log('MODAL FECHADO E EDITANDO');
        this.openLcto(this.controle);
        this.showEditOption = false;
      } else {
        console.log('MODAL FECHADO E CRIANDO');
        this.create();
        this.showEditOption = true;
      }
    }
    // Busca de texto padrão (Dados Adicionais) com debounce — mesmo fluxo do WhatsApp
    this.txtAddSearch$.pipe(
      takeUntil(this._onDestroy),
      debounceTime(400),
      switchMap(term => {
        this.txtAddLoading = true;
        return term
          ? this.txtAddService.getTxtAddPageSearch(1, 20, term)
          : this.txtAddService.getTxtAddPage(1, 20);
      })
    ).subscribe(
      (page: any) => {
        this.txtAddResults = page?.content || [];
        this.txtAddLoading = false;
      },
      () => this.txtAddLoading = false
    );

    this.doctoIs$.subscribe(log => {
      // console.log('>>>>>>>>>>>>log->doctoIs$:' + log.length);
      this.doctoIs = log.map(val => val);
      // console.log('>>>>>>>>>>>>log->doctoIs:' + this.doctoIs.length);
      this.doctoIs.forEach(i => console.log('>>>>>>>>>>>>>>i.id:' + i.id.fatProduto.codigo));
    });

    this.pageObjectDoctoI$.subscribe(
      page => {
        this.doctoCForm.setControl('items', this.fb.array([]));
        if (page != null) {
          this.doctoIs$.next(page.content);
          this.doctoIs = page.content;
          this.lengthItem = page.totalElements;
          this.pageSizeItem = page.size;
          this.pageItem = page.number;
          this.doctoCForm.setControl('items', this.itemFormArray);
          if (this.pageItem === 1) {
            this.paginatorItem.firstPage();
          }
        } else {
          this.doctoIs = [];
          this.doctoIs$.next([]);
        }
      });


    /**
     * Search Transacao
     */
    this.doctoCForm.get('searchTransacao')?.valueChanges
      .pipe(
        filter(search => !!search),
        tap(() => this.searching = true),
        takeUntil(this._onDestroy),
        debounceTime(200),
        map(search => {
          if (!this.fatTransacoes) {
            return [];
          }
          return this.fatTransacaoService.getFatTransacaoPageSearch(1, 10, search, undefined, undefined, undefined, undefined, 'FATURAMENTO').subscribe(transacoes => {
            this.fatTransacoes = transacoes.content;
            this.filteredTransacoes.next(this.filterTransacoesByCodigoDescricao(this.fatTransacoes, search));
          });
        }),
        delay(500),
        takeUntil(this._onDestroy)
      )
      .subscribe(result => {
        this.searching = false;
        const selecionada = this.doctoCForm.controls['fatTransacao']?.value ?? this.lcto?.fatTransacao;
        this.fatTransacoes = this.mergeById(this.fatTransacoes, selecionada);
        const search = this.doctoCForm.get('searchTransacao')?.value;
        this.filteredTransacoes.next(this.filterTransacoesByCodigoDescricao(this.fatTransacoes, search));
      },
      error => {
        this.searching = false;
        this.confirmService.confirm(
          {
            message: `A T E N Ç Ã O !  ERRO PESQUISANDO TRANSAÇÃO ... ${error}`,
            error: true
          });
      });

    /**
     * Search Destinatário
     */
    this.doctoCForm.get('searchDestinatario')?.valueChanges
      .pipe(
        filter(search => !!search),
        tap(() => this.searching = true),
        takeUntil(this._onDestroy),
        debounceTime(200),
        map(search => {
          if (!this.destinatarios) {
            return [];
          }
          return this.cadastroService.getCadastroPageSearch(1, 10, search+'').subscribe(destinatarios => {
            this.filteredDestinatarios.next(destinatarios.content);
            this.destinatarios = destinatarios.content;
          });
        }),
        delay(200),
        takeUntil(this._onDestroy)
      )
      .subscribe(result => {
        this.searching = false;
        const selecionado = this.doctoCForm.controls['cadCadastro']?.value ?? this.lcto?.cadCadastro;
        this.destinatarios = this.mergeById(this.destinatarios, selecionado);
        this.filteredDestinatarios.next(this.destinatarios);
      },
      error => {
        this.searching = false;
        this.confirmService.confirm(
          {
            message: `A T E N Ç Ã O !  ERRO PESQUISANDO DESTINATÁRIO ... ${error}`,
            error: true
          });
      });

    /**
     * Search Vendedor
     */
    this.doctoCForm.get('searchVendedor')?.valueChanges
      .pipe(
        filter(search => !!search),
        tap(() => this.searching = true),
        takeUntil(this._onDestroy),
        debounceTime(200),
        map(search => {
          if (!this.vendedores) {
            return [];
          }
          return this.cadastroService.getCadastroPageSearch(1, 10, search, null, null, false, TipoCadastro.VENDEDORES).subscribe(vendedores => {
            this.vendedores = vendedores.content;
          });
        }),
        delay(500),
        takeUntil(this._onDestroy)
      )
      .subscribe(result => {
        this.searching = false;
        const selecionado = this.doctoCForm.controls['cadVendedor']?.value ?? this.lcto?.cadVendedor;
        this.vendedores = this.mergeById(this.vendedores, selecionado);
      },
      error => {
        this.searching = false;
        this.confirmService.confirm(
          {
            message: `A T E N Ç Ã O !  ERRO PESQUISANDO VENDEDOR ... ${error}`,
            error: true
          });
      });

    /**
     * Search Veículo (Ordem de Serviço) — mesma mecânica dos demais lookups da tela.
     */
    this.doctoCForm.get('searchVeiculo')?.valueChanges
      .pipe(
        filter(search => !!search),
        tap(() => this.searching = true),
        takeUntil(this._onDestroy),
        debounceTime(200),
        switchMap(search => this.veiculoService.getVeiculoPageSearch(1, 10, search)
          .pipe(catchError(() => of({ content: [] } as any)))),
        takeUntil(this._onDestroy)
      )
      .subscribe((page: any) => {
        this.searching = false;
        const selecionado = this.doctoCForm.controls['cadVeiculo']?.value ?? this.veiculo;
        this.veiculos = this.mergeById(page?.content ?? [], selecionado);
      },
      error => {
        this.searching = false;
        this.confirmService.confirm(
          {
            message: `A T E N Ç Ã O !  ERRO PESQUISANDO VEÍCULO ... ${error}`,
            error: true
          });
      });

    /**
     * Search Condição de Pgto
     */
    // this.doctoCForm.get('searchCondPg').valueChanges
    //   .pipe(takeUntil(this._onDestroy))
    //   .subscribe(() => {

    //     if (!this.condPgs) {
    //       return;
    //     }

    //     let search = this.doctoCForm.get('searchCondPg').value;

    //     if(!search){
    //       return this.condPgService.getCondPgPageSearch(1, 10, search).subscribe(condPgs => {
    //         this.filteredCondpgs.next(condPgs.content);
    //       });
    //     }

    //     // this.filterSearchCondpgs();
    //   });

    this.doctoCForm.get('searchCondPg')?.valueChanges
      .pipe(
        filter(search => !!search),
        tap(() => this.searching = true),
        takeUntil(this._onDestroy),
        debounceTime(250),
        map(search => {
          if (!this.condPgs) {
            return [];
          }
          return this.condPgService.getCondPgPageSearch(1, 10, search).subscribe(condPgs => {
            this.filteredCondpgs.next(condPgs.content);
            this.condPgs = condPgs.content;
          });
        }),
        delay(200),
        takeUntil(this._onDestroy)
      )
      .subscribe(result => {
        this.searching = false;
        const selecionada = this.doctoCForm.controls['fatCondPg']?.value ?? this.lcto?.fatCondPg;
        this.condPgs = this.mergeById(this.condPgs, selecionada);
        this.filteredCondpgs.next(this.condPgs);
      },
      error => {
        this.searching = false;
        this.confirmService.confirm(
          {
            message: `A T E N Ç Ã O !  ERRO PESQUISANDO CONDIÇÃO DE PAGAMENTO ... ${error}`,
            error: true
          });
      });

    /**
     * Search Lista de Preço
     */
    this.doctoCForm.get('searchLisPre')?.valueChanges
      .pipe(
        filter(search => !!search),
        tap(() => this.searching = true),
        takeUntil(this._onDestroy),
        debounceTime(200),
        map(search => {
          if (!this.listaPrecos) {
            return [];
          }
          return this.precoService.getListaPrecoPageSearch(1, 10, search).subscribe(lisPrecos => {
            this.listaPrecos = lisPrecos.content;
          });
        }),
        delay(500),
        takeUntil(this._onDestroy)
      )
      .subscribe(result => {
        this.searching = false;
        const selecionada = this.doctoCForm.controls['fatListaPreco']?.value ?? this.lcto?.fatListaPreco;
        this.listaPrecos = this.mergeById(this.listaPrecos, selecionada);
      },
      error => {
        this.searching = false;
        this.confirmService.confirm(
          {
            message: `A T E N Ç Ã O !  ERRO PESQUISANDO LISTA DE PREÇOS ... ${error}`,
            error: true
          });
      });

    /**
     * Search Série
     */
    this.doctoCForm.get('searchSerie')?.valueChanges
      .pipe(
        filter(search => !!search),
        tap(() => this.searching = true),
        takeUntil(this._onDestroy),
        debounceTime(200),
        map(search => {
          if (!this.series) {
            return [];
          }
          return this.serieService.getFatSeriePageSearch(1, 10, search).subscribe(s => {
            this.series = s.content;
          });
        }),
        delay(200),
        takeUntil(this._onDestroy)
      )
      .subscribe(result => {
        this.searching = false;
        const selecionada = this.doctoCForm.controls['serie']?.value ?? this.serie;
        this.series = this.mergeById(this.series, selecionada);
      },
      error => {
        this.searching = false;
        this.confirmService.confirm(
          {
            message: `A T E N Ç Ã O !  ERRO PESQUISANDO SERIE ... ${error}`,
            error: true
          });
      });

    this.serieService.getFatSeriePage(1, 10).subscribe(s => {
      this.series = s.content; this.selectSerie();
    });


    this.getPageItem(this.pageItem, this.pageSizeItem, this.lcto?.controle);
    // cria o timer p/ pesquisa.
    this.debounceTimeSearchItem();

  }
  filterSearchCondpgs() {
    throw new Error('Method not implemented.');
  }

  private selectSerie() {
    if (this.lcto?.serie !== undefined && this.lcto?.serie !== null) {
      if (this.series.map(n => n.id).includes(this.lcto.serie.id)) {
        const s = this.series.find(n => n.id === this.lcto.serie.id);
        this.doctoCForm.controls['serie'].setValue(s ?? this.lcto.serie);
      } else {
        this.series.push(this.lcto.serie);
      }
    }
  }

  get itemFormArray(): FormArray {
    return this.doctoCForm.get('items') as FormArray;
  }


  reloadLctoDetails(lcto: FatDoctoC) {
    this.lctoDetails = 'CONTROLE:' + lcto.controle + ' - TOTAL DO LCTO:'
      + formatCurrency(lcto.valortotalDocto, this.locale, getCurrencySymbol('BRL', 'wide'));
  }

  getControleLctoFormatado(): string {
    const controle = this.lcto?.controle;
    if (controle === null || controle === undefined || `${controle}`.trim() === '') {
      return 'N/D';
    }

    const controleNumero = Number(controle);
    if (!isNaN(controleNumero)) {
      return controleNumero.toString().padStart(10, '0');
    }

    return `${controle}`;
  }

  ngOnDestroy() {
    // this.stopPolling.next();
  }

  buildDoctoCForm(doctoC: FatDoctoC) {
    this.lcto = doctoC;
    this.doctoIs = doctoC?.items;
    this.doctoCForm = this.fatDoctoCUtilsService.buildDoctoCForm(this.fb, doctoC, this.disabled);

    if (doctoC !== undefined && doctoC !== null) {

      // Modelo da série manda nos botões de emissão (55/65=NF-e/NFC-e, 99=NFS-e).
      // Feito aqui porque é o ponto por onde passa todo carregamento do lançamento —
      // até então o flag só era ligado ao trocar série/transação.
      this.dfe = this.isModeloComEmissao(doctoC?.serie?.serieModelo);

      this.listaPreco = this.lcto?.fatListaPreco;
      this.listaPrecos.push(this.listaPreco);
      this.doctoCForm.controls['fatListaPreco'].setValue(this.listaPreco)
      this.carregarPoliticaListaPreco();


      if (this.lcto?.fatListaPreco?.id > 0 && this.lcto?.fatListaPrecoTabelaId > 0) {
        const seqLista = this.listaPrecoSeq;
        this.tabelaPrecoService.getTabela(this.lcto?.fatListaPreco.id, this.lcto?.fatListaPrecoTabelaId).subscribe(val => {
          if (seqLista !== this.listaPrecoSeq) {
            return; // lista/tabela já trocadas (cliente/transação) enquanto a gravada carregava
          }
          this.lcto.fatListaPrecoTabela = val;
          this.tabela = val;
          this.tabelaPrecoService.getTabelaPage(this.listaPreco.id, 1, 30).subscribe(tabelas => {
            this.tabelas = tabelas.content;
            this.tabelas$.next(tabelas.content);
            this.doctoCForm.controls['fatListaPrecoTabela'].setValue(val);
          });
        });
      }
      // Ordem de Serviço: veículo gravado e operação da transação (d122) para decidir o que mostrar.
      this.carregarVeiculos(this.lcto?.cadVeiculoId);
      this.carregarOperacaoDiretiva(this.lcto?.fatTransacao?.id);

      if (this.lcto?.cadastroVendedorId > 0) {
        this.cadastroService.getCadastro(this.lcto?.cadastroVendedorId)
          .subscribe(vendedor => {
            this.lcto.cadVendedor = vendedor;
            this.vendedores.push(this.lcto.cadVendedor);
            this.doctoCForm.controls['cadVendedor'].setValue(this.lcto.cadVendedor);
          });
      }


      this.fatTransacaoService.getFatTransacaoPage(1, 10, undefined, undefined, undefined, undefined, 'FATURAMENTO').subscribe(transacoes => {
        this.fatTransacoes = transacoes.content
        this.filteredTransacoes.next(this.fatTransacoes);
        if (this.lcto.fatTransacao !== undefined && this.lcto.fatTransacao !== null) {
          this.fatTransacoes.push(this.lcto.fatTransacao)
          this.filteredTransacoes.next(this.fatTransacoes);
          this.doctoCForm.controls['fatTransacao'].setValue(this.lcto.fatTransacao)
        }
      })


      this.cadastroService.getCadastroPage(1, 10).subscribe(destinatarios => {
        this.destinatarios = destinatarios.content
        if (this.lcto.cadCadastro !== undefined && this.lcto.cadCadastro !== null) {
          this.destinatarios.push(this.lcto.cadCadastro)
          this.filteredDestinatarios.next(this.destinatarios);
          this.doctoCForm.controls['cadCadastro'].setValue(this.lcto.cadCadastro)
          this.destinatario = this.lcto.cadCadastro;
          this.carregarEnderecosFaturamento(this.lcto.cadCadastro?.id, false);
        }
      })

      this.condPgService.getCondPgPage(1, 10).subscribe( condPgs => {
        this.condPgs = condPgs.content;
        this.condPgs.push(this.lcto.fatCondPg);
        this.filteredCondpgs.next(this.condPgs);
        this.doctoCForm.controls['fatCondPg'].setValue(this.lcto.fatCondPg);
      })


    }
    if (this.selectedTabIndex !== 0 && (this.lcto?.controle ?? 0) > 0) {
      this.reloadPageItem();
    }
  }


  /**
   * Lançamento aberto pelo cartão do funil já entra com o cliente da negociação.
   *
   * Grava também em lcto.cadCadastro porque a carga das listas (reloadLctoDetails) é assíncrona e
   * reaplica o cliente do lançamento quando termina. Sem isso, se ela voltar depois desta, o select
   * fica sem a opção e o cliente some da tela.
   */
  private preencherClienteDoFunil(): void {
    const cadastroId = Number(this.route.snapshot.queryParamMap.get('cadastroId'));
    if (!(cadastroId > 0)) {
      return;
    }
    this.cadastroService.getCadastro(cadastroId).subscribe(cadastro => {
      if (!cadastro?.id) {
        return;
      }
      this.lcto.cadCadastro = cadastro;
      if (!(this.destinatarios ?? []).some(d => d?.id === cadastro.id)) {
        this.destinatarios = [...(this.destinatarios ?? []), cadastro];
        this.filteredDestinatarios.next(this.destinatarios);
      }
      this.doctoCForm.controls['cadCadastro'].setValue(cadastro);
      this.onSelectionChangeDestinatario({ value: cadastro });
    });
  }

  /** Primeiro salvamento do lançamento aberto pelo funil: liga o documento ao cartão. */
  private vincularAoFunil(salvo: FatDoctoC): void {
    const oportunidadeId = this.oportunidadeIdDoFunil;
    if (!oportunidadeId || !(salvo?.controle > 0)) {
      return;
    }
    this.oportunidadeIdDoFunil = null;
    this.crmService.vincularLancamento(oportunidadeId, salvo.controle).subscribe({
      next: () => this.snack.open('Lançamento ligado à oportunidade do funil', 'OK', { duration: 4000 }),
      error: erro => {
        // Devolve a pendência: o próximo salvamento tenta de novo.
        this.oportunidadeIdDoFunil = oportunidadeId;
        this.snack.open(erro?.error?.mensagem ?? 'Não foi possível ligar ao funil', 'OK', { duration: 6000 });
      }
    });
  }

  create() {
    this.created = true;
    this.loader.open();
    // ?tipoLcto=ORDEM_SERVICO abre uma OS nova: o backend escolhe a transação padrão de OS
    // (fat_parameters) exatamente como o botão "Nova OS" do desktop.
    this.fatDoctoCService.create(this.tipoLcto).subscribe(val => {
      this.lcto = val;
      this.buildDoctoCForm(val);
      this.reloadLctoDetails(val);
      this.preencherClienteDoFunil();
      this.loader.close();
    }, ee => {
      this.loader.close();
      this.confirmService.confirm({ message: `ERRO AO CARREGAR LCTO: ${ee}`, error: true })
    }, () => {
      this.loader.close();
    });
  }

  openLcto(controle: number) {
    if(controle === undefined || controle === null || controle === 0){
      return;
    }
    this.created = false;
    this.loader.open();
    this.fatDoctoCService.getFatDoctoCClean(controle).subscribe(lcto => {
      this.lcto = lcto;
      this.buildDoctoCForm(lcto);
      this.reloadLctoDetails(lcto);



      this.loader.close();
    }, ee => {
      this.loader.close();
      this.confirmService.confirm({ message: `ERRO AO CARREGAR LCTO: ${ee}`, error: true })
    }, () => {
      this.loader.close();
    });
  }

  openWhatsapp(initialData?: any) {
    const openDialog = (dataObj: any) => {
      const dialogRef = this.dialog.open(WhatsappEditComponent, {
        width: this.layout.isMobile ? '100vw' : '720px',
        maxWidth: '100vw',
        height: this.layout.isMobile ? '100dvh' : undefined,
        maxHeight: '100dvh',
        data: dataObj ?? {}
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result?.success) {
          this.snack.open('Mensagem enviada com sucesso', 'OK', { duration: 3000 });
        } else if (result?.cancelled) {
          // usuário cancelou — não faz nada
        } else if (result && result.success === false) {
          this.snack.open('Erro ao enviar mensagem', 'OK', { duration: 4000 });
        }
        try {
          this.ref.markForCheck();
        } catch (e) { /* ignore */ }
      });
    };

    // se vier um form para gerar, gerar o PDF (ou PDF+XML) e passar como anexo
    if (initialData && initialData.form !== undefined && initialData.form !== null) {
      const payloadData = { ...initialData };
      // preenche telefone se não veio
      if (!payloadData.to) {
        payloadData.to = this.getDestPhone();
      }
      // gerar previa (pre-visualização) quando form === 'previa'
      if (initialData.form === 'previa') {
        this.loader.open('Gerando prévia...');
        this.fatDoctoCService.previa(this.lcto?.controle).pipe(finalize(() => this.loader.close()))
          .subscribe((response: ArrayBuffer) => {
            try {
              const blob = new Blob([response], { type: 'application/pdf' });
              const filename = `${this.lcto?.controle}-previa.pdf`;
              const file = new File([blob], filename, { type: 'application/pdf' });
              payloadData.files = [file];
            } catch (e) {
              console.warn('Erro criando arquivo prévia para WhatsApp:', e);
            }
            openDialog(payloadData);
          }, err => {
            console.warn('Falha ao gerar prévia, abrindo diálogo sem arquivo', err);
            openDialog(payloadData);
          });
        return;
      }

      // DF-e (form === 0): gerar PDF e XML
      if (initialData.form === 0) {
        this.loader.open('Gerando PDF e XML...');
        forkJoin({
          pdf: this.fatDoctoCService.printForm(this.lcto?.controle, 0, true),
          xml: this.fatDoctoCService.getNfeXml(this.lcto?.controle)
        }).pipe(finalize(() => this.loader.close()))
          .subscribe(result => {
            try {
              const pdfBlob = new Blob([result.pdf], { type: 'application/pdf' });
              const pdfName = `${this.lcto?.controle}-dfe.pdf`;
              const pdfFile = new File([pdfBlob], pdfName, { type: 'application/pdf' });
              const xmlBlob = new Blob([result.xml], { type: 'application/xml' });
              const xmlName = `${this.lcto?.controle}-dfe.xml`;
              const xmlFile = new File([xmlBlob], xmlName, { type: 'application/xml' });
              payloadData.files = [pdfFile, xmlFile];
            } catch (e) {
              console.warn('Erro criando arquivos PDF/XML para WhatsApp:', e);
            }
            openDialog(payloadData);
          }, err => {
            console.warn('Falha ao gerar PDF/XML, abrindo diálogo sem arquivos', err);
            openDialog(payloadData);
          });
        return;
      }

      // Formulários numéricos (1,2,3,...): gerar o PDF do formulário correspondente
      if (typeof initialData.form === 'number' && initialData.form > 0) {
        this.loader.open('Gerando formulário...');
        this.fatDoctoCService.printForm(this.lcto?.controle, initialData.form, true).pipe(finalize(() => this.loader.close()))
          .subscribe((response: ArrayBuffer) => {
            try {
              const blob = new Blob([response], { type: 'application/pdf' });
              const filename = `${this.lcto?.controle}-form${initialData.form}.pdf`;
              const file = new File([blob], filename, { type: 'application/pdf' });
              payloadData.files = [file];
            } catch (e) {
              console.warn('Erro criando arquivo PDF do formulário para WhatsApp:', e);
            }
            openDialog(payloadData);
          }, err => {
            console.warn('Falha ao gerar formulário, abrindo diálogo sem arquivo', err);
            openDialog(payloadData);
          });
        return;
      }
    }

    // caso padrão, preencher telefone se possível e abrir diálogo
    const data = initialData ?? {};
    if (!data.to) {
      data.to = this.getDestPhone();
    }
    openDialog(data);
  }

  /**
   * Retorna um objeto inicial para passar ao diálogo WhatsApp.
   * Aceita `number` (formulário) ou a string literal `'previa'`.
   * Pode ser chamado diretamente do template: (click)="openWhatsapp(getWhatsappInitialData(1))"
   */
  getWhatsappInitialData(form?: number | 'previa') {
    const data: any = {};
    if (form !== undefined && form !== null) {
      data.form = form;
    }
    const phone = this.getDestPhone();
    if (phone) {
      data.to = phone;
    }

    // --- Monta mensagem padrão ---
    const cad = this.doctoCForm?.value?.cadCadastro ?? this.lcto?.cadCadastro;
    const numero = this.doctoCForm?.value?.numeroDocto ?? this.lcto?.numeroDocto;
    const serie = this.doctoCForm?.value?.serie?.codigo ?? this.lcto?.serie?.codigo;
    const emissao = this.doctoCForm?.value?.emissao ?? this.lcto?.emissao;
    const valor = this.doctoCForm?.value?.valortotalDocto ?? this.lcto?.valortotalDocto;
    const modelo = this.doctoCForm?.value?.modelo ?? this.lcto?.serie.serieModelo;

    const nome = cad?.razaoSocial || cad?.nome || '';
    const dataEmissao = emissao ? (typeof emissao === 'string' ? emissao : (emissao.toLocaleDateString ? emissao.toLocaleDateString('pt-BR') : emissao)) : '';
    const valorFormatado = valor != null ? formatCurrency(valor, 'pt-BR', getCurrencySymbol('BRL', 'wide')) : '';
    const tipo = typeof form === 'number' ? `Formulário ${form}` : 'documento';

    // Se for prévia, mensagem especial
    if (form === 'previa') {
      data.message =
        'Estamos enviando esta prévia para conferência referente DF-e (*Documento Fiscal Eletrônico*) Solicialtado. Acreditamos que isso reforça o processo de conferência, ajudando a evitar erros. Pedimos que verifiquem se está tudo conforme solicitado, nos retorne um OK caso esteja tudo certo.';
    } else {
      // Verifica se é DF-e (NFe, CTe, etc)
      const isDFe = form === 0 ? true : false;    if (isDFe) {
        data.message =
          'Conforme o ajuste SINEF e os decretos relacionados à regulamentação de documentos fiscais eletrônicos no Brasil, segue em anexo arquivo referente ao DF-e.\n\n' +
          `Destinatário: ${nome}\n` +
          `Documento nº ${numero}${serie ? `, série ${serie}` : ''}${dataEmissao ? `, emitido em ${dataEmissao}` : ''}.\n` +
          (valorFormatado ? `Valor total: ${valorFormatado}.\n` : '') +
          'Qualquer dúvida, estamos à disposição.';
      } else {
        data.message =
          `Olá${nome ? `, ${nome}` : ''}!\n` +
          `Segue o ${tipo} referente ao documento nº ${numero ?? ''}${serie ? `, série ${serie}` : ''}${dataEmissao ? `, emitido em ${dataEmissao}` : ''}.\n` +
          (valorFormatado ? `Valor total: ${valorFormatado}.\n` : '') +
          'Qualquer dúvida, estamos à disposição.';
      }
    }

    console.log('WhatsApp initial data:', data);

    return data;
  }

  /**
   * Extrai o telefone do destinatário (prioridade: celular, telefone1, telefone2).
   * Retorna apenas dígitos ou null se não existir.
   */
  private getDestPhone(): string | null {
    const cad = this.doctoCForm?.value?.cadCadastro ?? this.doctoCForm?.controls['cadCadastro']?.value ?? this.lcto?.cadCadastro;
    if (!cad) {
      return null;
    }
    const raw = cad.celular ?? cad.telefone1 ?? cad.telefone2 ?? null;
    if (!raw) {
      return null;
    }
    const digits = ('' + raw).replace(/\D+/g, '');
    return digits.length > 0 ? digits : null;
  }

  // ------------------ METODOS P/ ABA ITEM -------------------//
  getPageItem(page: number, pageSize: number, controle: number) {
    if (controle !== undefined) {
      this.loader.open();
      this.fatDoctoCService.getPageItem(this.lcto?.controle, page, pageSize, this.selectedItemOrdem
        , this.selectedItemDirect).subscribe(val => {
        this.pageObjectDoctoI$.next(val); this.loader.close();
      })
    }
  }

  reloadPageItem() {
    this.pageItem = 1;
    this.getPageItem(this.pageItem, this.pageSizeItem, this.lcto?.controle);
  }

  /**
 * Retorna a página da pesquisa,
 * @param search valor a ser pesquisada
 * @param page numero da página requisitada, primeira página é 1
 * @param pageSize quantidade de itens a serem retornados
 */
  getSearchPageItem(search: string, page: number, pageSize: number) {
    if (page === 1) {
      this.paginatorItem.firstPage();
    }
    if (search === null || search === undefined || search.length === 0) {
      this.getPageItem(1, this.pageSizeItem, this.lcto?.controle);
    } else {
      // this.loader.open();
      this.fatDoctoCService.getPageItemSearch(this.lcto?.controle, page, pageSize, search, this.selectedItemOrdem
        , this.selectedItemDirect).subscribe(val => {
        this.pageObjectDoctoI$.next(val);
      });
    }
  }

  /**
   *
   * @param event Captura evento de mudança em alguma configuração no paginator e recarrega a lista.
   */
  setPageSizeOptionsItem(event: PageEvent) {
    this.pageSizeItem = event.pageSize;
    // salvar se lista são diferentes
    if (this.itemFormArray.dirty) {
      this.save()
    }
    if (this.searchInput.length > 0) {
      this.getSearchPageItem(this.searchInput, event.pageIndex + 1, event.pageSize);
    } else {
      this.getPageItem(event.pageIndex + 1, event.pageSize, this.lcto?.controle);
    }
  }

  searchBy_UsingDebounceItem(searchString: any) {
    this.searchInput = searchString;
    this.searchEntry$.next(this.searchInput);
  }

  debounceTimeSearchItem() {
    this.searchEntry$
      .pipe(debounceTime(250))
      .subscribe((s) => this.getSearchPageItem(s, 1, this.pageSizeItem));
  }

  deleteDoctoI(row: any) {
    this.confirmService.confirm({ message: `Deletar ${row?.id.fatProduto.codigo + '-' + row?.id.fatProduto.descricao}?` })
      .subscribe(res => {
        if (res) {
          setTimeout(() => this.isEditableDoctI = {}, 300)
          this.loader.open();
          this.fatDoctoCService.deleteItem(this.lcto?.controle, row.id.fatProduto.id)
            .subscribe(data2 => {
              this.loader.close();
              this.confirmService.confirm({
                title: !data2.erro ? 'Sucesso' : 'Erro', message: data2.status, error: !!data2.erro
              });
              if (!data2.erro) {
                this.buildDoctoCForm(data2.lcto);
                this.getPageItem(this.pageObjectDoctoI$?.value?.content.length > 1 ? this.pageItem : this.pageItem - 1
                  , this.pageSizeItem, this.lcto?.controle);
              }
            })
        }
      })
  }


  // ------------------ FIM DE METODOS P/ ABA ITEM -------------------//

  // ** Definições de Type ahead */

  // ------------------------------------------ ADD Vendedor ----------------------------------------

  onSelectionChangeVendedor(event: any): void {
    if (event.value !== undefined) {
      this.vendedor = event.value;
      this.clearSearchControl('searchVendedor');
    }
  }

  addVendedor() {
    const dialogRef: MatDialogRef<any> = this.dialog.open(CadastroTablePopupComponent, {
      width: this.layout.isMobile ? '100vw' : '1024px',
      maxWidth: '100vw',
      height: this.layout.isMobile ? '100dvh' : undefined,
      maxHeight: '100dvh',
      disableClose: true,
      data: { title: 'Novo Vendedor', payload: {} }
    })
    dialogRef.afterClosed()
      .subscribe(res => {
        if (!res) {
          return;
        }
        this.loader.open();
        this.cadastroService.saveOrUpdate(res)
          .subscribe(data => {
            this.loader.close();
            this.snack.open('Vendedor Salvo com sucesso!', 'OK', { duration: 5500 });
            this.vendedor = data;
            this.doctoCForm.patchValue({ destinatario: data });
          }, (err: HttpErrorResponse) => {
            this.loader.close();
            this.snack.open('Erro ao salvar o Grupo!', 'ERRO', { duration: 5500 });
          })
      })

  }
  // ----------------------- DESTINATARIO---------------------

  onSelectionChangeDestinatario(event: any): void {
    if (event.value !== undefined) {
      this.destinatario = event.value;
      this.clearSearchControl('searchDestinatario');
      this.doctoCForm.patchValue({ nome: this.destinatario.razaoSocial });
      this.doctoCForm.patchValue({
        cnpjCpf: this.destinatario.pessoa === 'Fisica' ? this.destinatario.cpf : this.destinatario.inscricaoFederal
      });
      this.preencherDadosAdicionaisEnderecoEntrega();
      this.carregarEnderecosFaturamento(this.destinatario?.id, true);
      this.alertarOcorrenciasCadastro(this.destinatario);
      this.aplicarListaPrecoResolvida();
    }
  }

  // ----------------------- LISTA / TABELA DE PREÇO ---------------------

  /** Política de lista/tabela: cliente → transação (d112/d113) → fat_parameters, mais a d134. */
  private resolverListaPreco(): Observable<ListaPrecoResolvida> {
    const cadastroId = this.destinatario?.id ?? this.doctoCForm?.value?.cadCadastro?.id;
    const transacaoId = this.fatTransacao?.id ?? this.doctoCForm?.value?.fatTransacao?.id;
    return this.fatDoctoCService.resolverListaPreco(cadastroId, transacaoId).pipe(takeUntil(this._onDestroy));
  }

  /** Última política resolvida para o cliente/transação do lançamento. */
  politicaListaPreco: ListaPrecoResolvida = null;
  /** Incrementa a cada troca de lista/tabela; descarta cargas assíncronas que ficaram velhas. */
  private listaPrecoSeq = 0;

  /**
   * Cliente com lista ou tabela no cadastro e transação com d134 = 3-Obrigatório: as duas ficam
   * travadas (a tabela pertence à lista; o trigger dos itens rejeitaria outra). Com 2-Somente avisar
   * segue livre e conferirPoliticaListaPreco pergunta; com 1-Não obrigatório, livre.
   */
  get listaPrecoTravadaPeloCadastro(): boolean {
    const politica = this.politicaListaPreco;
    return Number(politica?.d134ObrigatorioInformePrecoTabela ?? 1) === D134_OBRIGATORIO
      && (politica?.origemLista === 'CADASTRO' || politica?.origemTabela === 'CADASTRO');
  }

  /** Ao trocar o cliente, o lançamento passa a usar a lista/tabela dele (ou os fallbacks). */
  private aplicarListaPrecoResolvida(): void {
    this.resolverListaPreco().subscribe(
      politica => {
        this.politicaListaPreco = politica;
        this.selecionarListaTabelaPreco(politica?.fatListaPreco, politica?.fatListaPrecoTabela);
      },
      () => { }
    );
  }

  /** Ao abrir um lançamento: só descobre se a lista vem do cadastro (para travar), sem trocar nada. */
  private carregarPoliticaListaPreco(): void {
    this.resolverListaPreco().subscribe(politica => (this.politicaListaPreco = politica), () => { });
  }

  /** Troca lista/tabela (mesmo critério da venda-dialog): só se mudou, e oferece reprecificar os itens. */
  private selecionarListaTabelaPreco(lista: ListaPreco, tabela: ListaPrecoTabela): void {
    if (!lista?.id || this.listaPrecoBloqueadaPorBaixa) {
      return;
    }
    const tabelaId = tabela?.id?.tabelaId ?? null;
    const listaAtualId = this.doctoCForm.controls['fatListaPreco']?.value?.id ?? this.lcto?.fatListaPreco?.id;
    const tabelaAtualId = this.doctoCForm.controls['fatListaPrecoTabela']?.value?.id?.tabelaId
      ?? this.lcto?.fatListaPrecoTabelaId ?? null;
    if (lista.id === listaAtualId && tabelaId === tabelaAtualId) {
      return;
    }
    // Invalida a carga assíncrona da tabela gravada (buildDoctoCForm), que chegaria depois e voltaria a antiga.
    this.listaPrecoSeq++;
    this.listaPreco = lista;
    this.listaPrecos = this.mergeById(this.listaPrecos, lista);
    this.doctoCForm.controls['fatListaPreco'].setValue(lista);
    this.tabelaPrecoService.getTabelaPage(lista.id, 1, 30).subscribe(tabelas => {
      this.tabelas = tabelas.content;
      this.tabelas$.next(tabelas.content);
      this.doctoCForm.controls['fatListaPrecoTabela'].setValue(tabela ?? null);
      this.perguntarReprecificarItens();
    });
  }

  /** Baixa no financeiro: lista/tabela não podem mais mudar (mesma trava da venda-dialog). */
  get listaPrecoBloqueadaPorBaixa(): boolean {
    return !!this.lcto?.contemBaixa;
  }

  /**
   * Lançamento gravado e com itens: pergunta se atualiza o preço deles pela lista/tabela nova.
   * Perguntar (e não reprecificar direto como a venda) porque o lançamento também atende compras.
   */
  private perguntarReprecificarItens(): void {
    const controle = this.lcto?.controle;
    if (!controle || this.listaPrecoBloqueadaPorBaixa) {
      return;
    }
    this.fatDoctoCService.getPageItem(controle, 1, 1000, 'NENHUM', 'ASC')
      .pipe(takeUntil(this._onDestroy))
      .subscribe(page => {
        const itens = page?.content ?? [];
        if (!itens.length) {
          return;
        }
        this.confirmService.confirm({
          title: 'Lista/tabela de preço alterada',
          icon: 'price_change',
          message: `Atualizar o preço de ${itens.length} item(ns) já lançado(s) pela nova lista/tabela?`
            + '\n\nO lançamento será gravado antes da atualização.',
          okText: 'Atualizar preços', cancelText: 'Manter preços'
        }).subscribe(ok => {
          if (ok) {
            this.reprecificarItens(controle, itens);
          }
        });
      }, () => { });
  }

  /**
   * Grava o cabeçalho primeiro (o trigger dos itens confere a lista/tabela gravada, d134) e depois
   * regrava cada item com o preço da lista/tabela — mesma montagem da venda-dialog.
   */
  private reprecificarItens(controle: number, itens: FatDoctoI[]): void {
    const listaId = this.doctoCForm.controls['fatListaPreco']?.value?.id;
    const tabelaId = this.doctoCForm.controls['fatListaPrecoTabela']?.value?.id?.tabelaId;
    this.save(false, false)
      .pipe(filter(doc => !!doc?.controle), take(1))
      .subscribe(doc => {
        this.loader.open('Atualizando preços dos itens...');
        forkJoin(itens.map(item => this.produtoService.getProdutoById(item?.id?.fatProduto?.id)))
          .pipe(
            switchMap((produtos: Produto[]) => forkJoin(itens.map((item, i) => {
              const valorUnitario = precoProdutoPorListaTabela(produtos?.[i], listaId, tabelaId) || 0;
              const descPercUnitario = item.descPercUnitario || 0;
              const doctoI = {} as FatDoctoI;
              doctoI.id = {} as ItemID;
              doctoI.id.fatProduto = { id: item?.id?.fatProduto?.id } as any;
              doctoI.id.fatDoctoCControle = controle;
              doctoI.uuid = doc.uuid;
              doctoI.qtde = item.qtde;
              doctoI.valorUnitario = valorUnitario;
              doctoI.valorTotal = valorUnitario * item.qtde;
              doctoI.descPercUnitario = descPercUnitario;
              doctoI.descValorUnitario = valorUnitario * (descPercUnitario / 100);
              return this.fatDoctoCService.saveOrUpdateItem(doctoI);
            }))),
            finalize(() => this.loader.close())
          )
          .subscribe(
            () => this.openLcto(controle),
            error => this.confirmService.confirm({
              message: 'Erro ao atualizar preços dos itens: ' + extractBackendErrorMessage(error),
              error: true
            })
          );
      }, () => { /* o próprio save() já reporta o erro */ });
  }

  /**
   * Diretiva 134 ao escolher lista/tabela à mão, quando o cliente tem lista/tabela própria:
   * 2-Somente avisar pergunta se corrige; 3-Obrigatório corrige direto (o trigger dos itens
   * rejeitaria a lista/tabela diferente da do cadastro).
   */
  private conferirPoliticaListaPreco(listaId: number, tabelaId?: number): void {
    this.resolverListaPreco().subscribe(politica => {
      this.politicaListaPreco = politica;
      const d134 = Number(politica?.d134ObrigatorioInformePrecoTabela ?? 1);
      const divergencia = divergenciaListaPrecoCliente(politica, listaId, tabelaId);
      if (!divergencia || d134 < D134_SOMENTE_AVISAR) {
        return;
      }
      if (d134 === D134_OBRIGATORIO) {
        this.selecionarListaTabelaPreco(politica.fatListaPreco, politica.fatListaPrecoTabela);
        this.confirmService.confirm({
          title: 'A T E N Ç Ã O !',
          message: `${divergencia}\nA transação exige a lista/tabela do cliente (diretiva 134). O sistema corrigiu.`,
          error: true
        });
        return;
      }
      this.confirmService.confirm({
        title: 'A T E N Ç Ã O !',
        message: `${divergencia}\n\nDeseja que o sistema corrija?`
      }).subscribe(ok => {
        if (ok) {
          this.selecionarListaTabelaPreco(politica.fatListaPreco, politica.fatListaPrecoTabela);
        }
      });
    }, () => { });
  }

  onSelectionChangeTabelaPreco(event: any): void {
    const tabelaId = event?.value?.id?.tabelaId;
    const listaId = this.doctoCForm.controls['fatListaPreco']?.value?.id;
    if (tabelaId && listaId) {
      this.listaPrecoSeq++;
      this.conferirPoliticaListaPreco(listaId, tabelaId);
      this.perguntarReprecificarItens();
    }
  }

  /**
   * Ao selecionar o Cliente/Fornecedor, alerta as ocorrências ativas — espelha o desktop
   * (VendaController / ActionSalvarVenda). Filtra por avisar em {QDO_FATURAR(2), SEMPRE(3)} e
   * pela janela de validade (dataAvisarInicial <= hoje <= dataAvisarFinal). Só executa se a
   * diretiva da transação tiver d135ChecaOcorrenciaCadastro (default true, como no desktop).
   */
  private alertarOcorrenciasCadastro(cad: any): void {
    const cadastroId = cad?.id;
    if (!cadastroId) {
      return;
    }
    const transacaoId = this.fatTransacao?.id ?? this.doctoCForm?.value?.fatTransacao?.id;
    const diretiva$ = (transacaoId !== undefined && transacaoId !== null)
      ? this.fatTransacaoService.getDiretiva(transacaoId)
      : of(null as any);

    diretiva$.pipe(takeUntil(this._onDestroy)).subscribe(diretiva => {
      const checa = diretiva?.d135ChecaOcorrenciaCadastro ?? true;
      if (!checa) {
        return;
      }
      this.cadastroService.getOcorrenciasList(cadastroId)
        .pipe(takeUntil(this._onDestroy))
        .subscribe(ocorrencias => {
          const mensagem = this.montarMensagemOcorrencias(ocorrencias ?? []);
          if (mensagem) {
            this.confirmService.confirm({
              title: `O Sistema detectou Ocorrência(s) para Cliente/Fornecedor: ${(cad?.razaoSocial ?? '').trim()}`,
              message: mensagem,
              error: true
            });
          }
        });
    });
  }

  private montarMensagemOcorrencias(ocorrencias: CadastroOcorrencia[]): string {
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    const hojeMs = hoje.getTime();
    // A API serializa as datas como "yyyy-MM-dd'T'hh:mm:ss"; normaliza p/ meia-noite local
    // pegando só a parte da data (10 primeiros chars) — evita cair no fallback por parse inválido.
    const toMeiaNoiteMs = (data?: string, fallback = hojeMs): number => {
      if (!data) {
        return fallback;
      }
      const d = new Date(`${`${data}`.substring(0, 10)}T00:00:00`);
      return isNaN(d.getTime()) ? fallback : d.getTime();
    };

    return (ocorrencias ?? [])
      // avisar em {QDO_FATURAR(2), SEMPRE(3)} — igual ao desktop (código 1 não dispara)
      .filter(o => ['2', '3'].includes(o?.avisar?.codigo))
      // janela de validade: dataAvisarInicial <= hoje <= dataAvisarFinal (nulo = sem limite naquele lado)
      .filter(o => {
        const ini = toMeiaNoiteMs(o?.dataAvisarInicial);
        const fim = toMeiaNoiteMs(o?.dataAvisarFinal);
        return hojeMs >= ini && hojeMs <= fim;
      })
      .map(o => {
        const texto = `${o?.ocorrencia ?? ''}`.split('-').map(t => t.trim()).filter(t => t.length > 0).join('\n');
        const data = o?.dataOcorrencia ? new Date(`${`${o.dataOcorrencia}`.substring(0, 10)}T00:00:00`).toLocaleDateString('pt-BR') : '';
        return `Ocorrência:\n${texto}\n\nData Ocorrência: ${data}`;
      })
      .join('\n');
  }

  private preencherDadosAdicionaisEnderecoEntrega(): void {
    if (!this.destinatario?.id) {
      const atual = `${this.doctoCForm.controls['dadosadicionais']?.value ?? ''}`;
      const semEnderecoEntrega = this.atualizarLinhaEnderecoEntrega(atual, '');
      this.doctoCForm.patchValue({ dadosadicionais: semEnderecoEntrega }, { emitEvent: false });
      return;
    }

    this.cadastroService.getPageEndereco(1, 200, 'id', 'DESC', `${this.destinatario.id}`)
      .pipe(takeUntil(this._onDestroy))
      .subscribe(page => {
        const enderecos = page?.content ?? [];
        const enderecoEntrega = enderecos.find((e: any) => !!e?.entrega);
        if (!enderecoEntrega || !enderecoEntrega?.endereco) {
          const atual = `${this.doctoCForm.controls['dadosadicionais']?.value ?? ''}`;
          const semEnderecoEntrega = this.atualizarLinhaEnderecoEntrega(atual, '');
          this.doctoCForm.patchValue({ dadosadicionais: semEnderecoEntrega }, { emitEvent: false });
          return;
        }

        const textoEntrega = this.montarTextoEnderecoEntrega(enderecoEntrega);
        const atual = `${this.doctoCForm.controls['dadosadicionais']?.value ?? ''}`;
        const novoValor = this.atualizarLinhaEnderecoEntrega(atual, textoEntrega);
        this.doctoCForm.patchValue({ dadosadicionais: novoValor }, { emitEvent: false });
      });
  }

  /**
   * Endereços do cadastro disponíveis como endereço de faturamento.
   * Com redefinir=true (troca de destinatário) aplica o fallback padrão -> cobrança;
   * sem nenhum dos dois, fica nulo, que significa faturar no endereço do próprio cadastro.
   */
  private carregarEnderecosFaturamento(cadastroId?: number, redefinir: boolean = false): void {
    if (!cadastroId) {
      this.enderecosFaturamento = [];
      this.doctoCForm.controls['cadCadastroEndereco']?.setValue(null);
      return;
    }

    this.cadastroService.getPageEndereco(1, 200, 'id', 'ASC', `${cadastroId}`)
      .pipe(takeUntil(this._onDestroy))
      .subscribe(page => {
        this.enderecosFaturamento = (page?.content ?? []).filter((e: any) => !!e?.endereco);

        const selecionado = this.doctoCForm.controls['cadCadastroEndereco']?.value;
        const aindaVale = !redefinir && this.enderecosFaturamento.some((e: any) => e?.id === selecionado?.id);
        if (aindaVale) {
          // reaproveita a instância da lista p/ o mat-select casar por referência
          this.doctoCForm.controls['cadCadastroEndereco']
            .setValue(this.enderecosFaturamento.find((e: any) => e?.id === selecionado?.id));
          return;
        }

        const padrao = this.enderecosFaturamento.find((e: any) => !!e?.padrao)
          ?? this.enderecosFaturamento.find((e: any) => !!e?.cobranca)
          ?? null;
        this.doctoCForm.controls['cadCadastroEndereco']?.setValue(padrao);
      });
  }

  /** casa a opção do combo pelo id (o valor gravado vem da API, não é a mesma instância da lista) */
  compareById = (a: any, b: any): boolean => (a?.id ?? null) === (b?.id ?? null);

  /** rótulo do endereço no combo de faturamento */
  descricaoEnderecoFaturamento(endereco: any): string {
    if (!endereco) {
      return 'Padrão do cadastro (usa o endereço padrão/cobrança; sem nenhum, o do cliente)';
    }
    const numero = `${endereco?.numero ?? ''}`.trim();
    const bairro = `${endereco?.bairro ?? ''}`.trim();
    const cidade = `${endereco?.cadMun?.municipio ?? ''}`.trim();
    const uf = `${endereco?.cadMun?.uf ?? ''}`.trim();
    const marcas = [endereco?.padrao ? 'PADRÃO' : '', endereco?.cobranca ? 'COBRANÇA' : '', endereco?.entrega ? 'ENTREGA' : '']
      .filter(m => !!m).join('/');
    return `${`${endereco?.endereco ?? ''}`.trim()}${numero ? ', ' + numero : ''}`
      + `${bairro ? ' - ' + bairro : ''}${cidade ? ' - ' + cidade + '/' + uf : ''}`
      + `${marcas ? ' [' + marcas + ']' : ''}`;
  }

  private montarTextoEnderecoEntrega(endereco: any): string {
    const logradouro = `${endereco?.endereco ?? ''}`.trim();
    const numero = `${endereco?.numero ?? ''}`.trim();
    const bairro = `${endereco?.bairro ?? ''}`.trim();
    const cidade = `${endereco?.cadMun?.municipio ?? this.destinatario?.cadMun?.municipio ?? ''}`.trim();
    const uf = `${endereco?.cadMun?.uf ?? this.destinatario?.cadMun?.uf ?? ''}`.trim();
    const cep = `${endereco?.cep ?? ''}`.trim();
    const telefone = `${endereco?.telefone1 ?? endereco?.celular ?? endereco?.telefone2 ?? ''}`.trim();

    const numeroFmt = numero ? `, ${numero}` : '';
    const bairroFmt = bairro ? ` - ${bairro}` : '';
    const cidadeUfFmt = (cidade || uf) ? ` - ${cidade}/${uf}`.replace('/$', '') : '';
    const cepFmt = cep ? ` - CEP ${cep}` : '';
    const telefoneFmt = telefone ? ` - FONE ${telefone}` : '';

    return `[ENDERECO_ENTREGA]: ${logradouro}${numeroFmt}${bairroFmt}${cidadeUfFmt}${cepFmt}${telefoneFmt}`.trim();
  }

  private atualizarLinhaEnderecoEntrega(textoAtual: string, linhaEntrega: string): string {
    const semBlocoAnterior = textoAtual
      .split('\n')
      .filter(linha => !linha.trim().startsWith('[ENDERECO_ENTREGA]:'))
      .join('\n')
      .trim();

    if (!linhaEntrega?.trim()) {
      return semBlocoAnterior;
    }

    return semBlocoAnterior ? `${semBlocoAnterior}\n${linhaEntrega}` : linhaEntrega;
  }


  addDestinatario() {
    const dialogRef: MatDialogRef<any> = this.dialog.open(CadastroTablePopupComponent, {
      width: this.layout.isMobile ? '100vw' : '1024px',
      maxWidth: '100vw',
      height: this.layout.isMobile ? '100dvh' : undefined,
      maxHeight: '100dvh',
      disableClose: true,
      data: { title: 'Novo Cadastro', payload: {} }
    })
    dialogRef.afterClosed()
      .subscribe(res => {
        if (!res) {
          return;
        }
        this.loader.open();
        this.cadastroService.saveOrUpdate(res)
          .subscribe(data => {
            this.loader.close();
            this.snack.open('Destinatário Salvo com sucesso!', 'OK', { duration: 5500 });
            this.destinatario = data;
            this.doctoCForm.patchValue({ destinatario: data });
          }, (err: HttpErrorResponse) => {
            this.loader.close();
            this.snack.open('Erro ao salvar o Grupo!', 'ERRO', { duration: 5500 });
          })
      })
  }

  // ------------------------------------------ Transacao ----------------------------------------

  private filterTransacoesByCodigoDescricao(transacoes: Transacao[], search: string): Transacao[] {
    const termo = (search ?? '').toString().trim().toLowerCase();
    if (!termo) {
      return transacoes ?? [];
    }

    const termos = termo.split(/\s+/).filter(Boolean);
    return (transacoes ?? []).filter(transacao => {
      const codigo = (transacao?.codigo ?? '').toString().toLowerCase();
      const descricao = (transacao?.descricao ?? '').toString().toLowerCase();
      const conteudo = `${codigo} ${descricao}`;
      return termos.every(t => conteudo.includes(t));
    });
  }

  private mergeById<T extends { id?: any }>(list: T[], selected?: T | null): T[] {
    const result = Array.isArray(list) ? [...list] : [];
    if (!selected?.id) {
      return result;
    }
    if (!result.some(item => item?.id === selected.id)) {
      result.unshift(selected);
    }
    return result;
  }

  private clearSearchControl(controlName: string): void {
    this.doctoCForm?.controls?.[controlName]?.setValue('', { emitEvent: false });
    this.searching = false;
  }

  // ------------------------------- ORDEM DE SERVIÇO ------------------------------- //

  /**
   * A OS é o MESMO lançamento, com os campos de oficina à mostra — igual ao desktop, onde
   * ordemServico.fxml e venda.fxml compartilham o VendaController. Aparece quando a empresa tem o
   * módulo Serviços Mecânico ligado (layout setado), quando a transação é de OS (diretiva d122 = 4,
   * o que o backend traduz em TipoLcto.ORDEM_SERVICO) ou quando o documento já tem dados de oficina
   * gravados — senão um lançamento antigo esconderia o que já está preenchido.
   */
  get isOrdemServico(): boolean {
    return this.layoutConf?.isEmpresaServicoMecanico === true
      || this.operacaoDiretiva === 4
      || this.tipoLcto === 'ORDEM_SERVICO'
      || this.temDadosDeOficina;
  }

  private get temDadosDeOficina(): boolean {
    return this.lcto?.cadVeiculoId > 0
      || !!`${this.lcto?.defeitoreclamado ?? ''}`.trim()
      || !!`${this.lcto?.defeitoconstatado ?? ''}`.trim();
  }

  /** Na oficina quem atende é o mecânico; o campo gravado continua sendo o vendedor. */
  get rotuloVendedor(): string {
    return this.isOrdemServico ? 'Mecânico/Vendedor' : 'Vendedor';
  }

  get rotuloDocumento(): string {
    return this.isOrdemServico ? 'Ordem de Serviço' : 'Lançamento';
  }

  displayVeiculo(veiculo: Veiculo): string {
    if (!veiculo) {
      return '';
    }
    return [`${veiculo.placa1 ?? ''}`.trim(), `${veiculo.descricaoVeiculo ?? ''}`.trim()]
      .filter(Boolean).join(' - ');
  }

  onSelectionChangeVeiculo(event: any): void {
    const selecionado: Veiculo = event?.value ?? null;
    this.clearSearchControl('searchVeiculo');
    this.veiculo = selecionado;
    this.veiculos = this.mergeById(this.veiculos, selecionado);
    // cadVeiculoId é o que a entidade grava; cadVeiculo é só o objeto exibido no combo.
    this.doctoCForm.patchValue({ cadVeiculoId: selecionado?.id ?? null });
    this.doctoCForm.controls['cadVeiculo'].markAsDirty();
  }

  /** Carrega a primeira página de veículos e o que já estiver gravado no documento. */
  private carregarVeiculos(cadVeiculoId?: number): void {
    this.veiculoService.getVeiculoPage(1, 10)
      .pipe(takeUntil(this._onDestroy), catchError(() => of({ content: [] } as any)))
      .subscribe((page: any) => {
        this.veiculos = this.mergeById(page?.content ?? [], this.veiculo);
        if (!(cadVeiculoId > 0)) {
          return;
        }
        this.veiculoService.getVeiculo(cadVeiculoId)
          .pipe(takeUntil(this._onDestroy), catchError(() => of(null as Veiculo)))
          .subscribe(veiculo => {
            if (!veiculo) {
              return;
            }
            this.veiculo = veiculo;
            this.veiculos = this.mergeById(this.veiculos, veiculo);
            this.doctoCForm.controls['cadVeiculo'].setValue(veiculo, { emitEvent: false });
          });
      });
  }

  /** Guarda a operação da diretiva (d122) para saber se a transação é de Ordem de Serviço. */
  private carregarOperacaoDiretiva(transacaoId?: number): void {
    if (!(transacaoId > 0)) {
      this.operacaoDiretiva = null;
      return;
    }
    this.fatTransacaoService.getDiretiva(transacaoId)
      .pipe(takeUntil(this._onDestroy), catchError(() => of(null)))
      .subscribe(diretiva => {
        this.operacaoDiretiva = diretiva?.d122Operacao ?? null;
      });
  }

  onSelectOpenedChange(controlName: string, opened: boolean): void {
    if (!opened) {
      this.clearSearchControl(controlName);
    }
  }


  onSelectionChangeFatTransacao(event: any): void {
    if (event.value !== undefined) {
      this.clearSearchControl('searchTransacao');
      this.loader.open();
      this.fatTransacao = event.value;
      this.fatDoctoCService.changeTransacao(this.doctoCForm.value).subscribe(lcto => {
        this.buildDoctoCForm(lcto);
        this.reloadLctoDetails(lcto);
        // Igual à venda-dialog: a d134 e as d112/d113 são da transação, então a lista/tabela
        // (e a trava) são resolvidas de novo. O backend só reaplica isso em documento novo.
        this.aplicarListaPrecoResolvida();
        if (this.fatTransacao && this.fatTransacao.id !== undefined) {
          this.fatTransacaoService
            .getDiretiva(this.fatTransacao.id).subscribe((diretiva) => {
              if (diretiva.d119NFe) {
                this.dfe = true;
              }
              // d122 = 4 é Ordem de Serviço: trocar a transação pode entrar ou sair desse modo.
              this.operacaoDiretiva = diretiva?.d122Operacao ?? null;

            });
        }
        this.loader.close();
      }, err => {
        this.loader.close();
        this.deleteLog();
        this.confirmService.confirm({
          title: 'A T E N Ç Ã O !!  ',
          message: 'ERRO ALTERANDO TRANSAÇÃO VERIFIQUE:\n err.error.status', error: true
        })
      });
    }
  }

  // ------------------- FIM TRANSACAO ----------------- //

  // ------------------------------------------ Serie ----------------------------------------
  onFocusSerie(event: FocusEvent) {
    this.doctoCForm.get('serie').valueChanges
      .pipe(
        debounceTime(100),
        tap(() => this.isLoadingSerie = true),
        switchMap(value => ((typeof (value) === 'string') ?
          (value !== undefined && value !== '' ? this.serieService.getFatSeriePageSearch(1, 10, value) :
            this.serieService.getFatSeriePage(1, 10)) : new Observable<PageResult<FatSerie>>())
          .pipe(
            finalize(() => this.isLoadingSerie = false),
          )
        )
      ).subscribe(series => this.series = series.content);
  }

  onSelectionChangeSerie(event: any): void {
    if (event.value !== undefined) {
      this.serie = event.value;
      this.dfe = this.isModeloComEmissao(this.serie?.serieModelo);
    }
  }

  displayFnSerie(cad: FatSerie) {
    if (cad) {
      return `${cad.codigo} - ${cad.descricao.trim()}`;
    }
  }



  //  ---------------------------------------- add condPg ---------------------------------------

  onSelectionChangeCondPg(event: any): void {
    if (event.value !== undefined) {
      this.condPg = event.value;
      this.clearSearchControl('searchCondPg');
    }
  }


  addCondPg() {
    const dialogRef: MatDialogRef<any> = this.dialog.open(CondpgPopupComponent, {
      width: this.layout.isMobile ? '100vw' : '1024px',
      maxWidth: '100vw',
      height: this.layout.isMobile ? '100dvh' : undefined,
      maxHeight: '100dvh',
      disableClose: true,
      data: { title: 'Nova condição de pagamento', payload: {} }
    })
    dialogRef.afterClosed()
      .subscribe(res => {
        if (!res) {
          return;
        }
        this.loader.open();
        this.condPgService.saveOrUpdate(res)
          .subscribe(data => {
            this.loader.close();
            this.snack.open('Condição de pagamento salva com sucesso!', 'OK', { duration: 5500 });
            this.condPg = data;
            this.doctoCForm.patchValue({ condPg: data });
          }, (err: HttpErrorResponse) => {
            this.loader.close();
            this.snack.open('Erro ao salvar a condição de pagamento!', 'ERRO', { duration: 5500 });
          })
      })

  }
  // ------------------------------------------------- add lista preço ----------------------------------------

  // onFocusListaPreco(event: FocusEvent) {
  //   this.doctoCForm.get('fatListaPreco').valueChanges
  //     .pipe(
  //       debounceTime(100),
  //       tap(() => this.isLoadingPreco = true),
  //       switchMap(value => ((typeof (value) === 'string') ?
  //         (value !== undefined && value !== '' ? this.precoService.getListaPrecoPageSearch(1, 10, value) :
  //           this.precoService.getListaPrecoPage(1, 10)) : new Observable<PageResult<ListaPreco>>())
  //         .pipe(
  //           finalize(() => this.isLoadingPreco = false),
  //         )
  //       )
  //     ).subscribe(precos => this.listaPrecos$.next(precos.content));
  // }


  onSelectionChangeListaPreco(event: any): void {
    if (event.value !== undefined) {
      this.listaPrecoSeq++;
      this.listaPreco = event.value;
      this.clearSearchControl('searchLisPre');
      // Igual à venda-dialog: a tabela anterior é de outra lista — limpa e espera a nova escolha
      // (o repreço dos itens é oferecido ao escolher a tabela).
      this.doctoCForm.controls['fatListaPrecoTabela'].setValue(null);
      this.tabelaPrecoService.getTabelaPage(this.listaPreco.id, 1, 30).subscribe(tabelas => {
        this.tabelas = tabelas.content
        this.tabelas$.next(tabelas.content)
      });
      this.conferirPoliticaListaPreco(this.listaPreco?.id);
    }
  }

  // displayFnListaPreco(lista: ListaPreco) {
  //   if (lista) {
  //     return `${lista.codigo.toString().padStart(5, '0')} - ${lista.descricao.trim()}`;
  //   }
  // }

  addListaPreco() {
    const dialogRef: MatDialogRef<any> = this.dialog.open(PrecoTablePopupComponent, {
      width: this.layout.isMobile ? '100vw' : '1024px',
      maxWidth: '100vw',
      height: this.layout.isMobile ? '100dvh' : undefined,
      maxHeight: '100dvh',
      disableClose: true,
      data: { title: 'Nova Lista de preços', payload: {} }
    })
    dialogRef.afterClosed()
      .subscribe(res => {
        if (!res) {
          return;
        }
        this.loader.open();
        this.precoService.saveOrUpdate(res)
          .subscribe(data => {
            this.loader.close();
            this.snack.open('Lista de preços Salvo com sucesso!', 'OK', { duration: 5500 });
            this.listaPreco = data;
            this.doctoCForm.patchValue({ ListaPreco: data });
          }, (err: HttpErrorResponse) => {
            this.loader.close();
            this.snack.open('Erro ao salvar a Lista de preços!', 'ERRO', { duration: 5500 });
          })
      })

  }

  // ----------------------------------------- add tabela ----------------------------------------------

  // onFocusListaTabela(event: FocusEvent) {
  //   this.doctoCForm.get('fatListaPrecoTabela').valueChanges
  //     .pipe(
  //       debounceTime(100),
  //       tap(() => this.isLoadingTabela = true),
  //       switchMap(value => ((typeof (value) === 'string') ?
  //         (value !== undefined && value !== '' ? this.tabelaPrecoService.getTabelaPageSearch(this.listaPreco.id, 1, 10, value) :
  //           this.tabelaPrecoService.getTabelaPage(this.listaPreco.id, 1, 10)) : new Observable<PageResult<ListaPrecoTabela>>())
  //         .pipe(
  //           finalize(() => this.isLoadingTabela = false),
  //         )
  //       )
  //     )
  //     .subscribe(tabelas => this.tabelas$.next(tabelas.content));
  // }


  // onSelectionChangeListaTabela(event: any): void {
  //   if (event.value !== undefined) {
  //     this.tabela = event.option.value;
  //   }
  // }

  // displayFnListaTabela(tabela: ListaPrecoTabela) {
  //   if (tabela) {
  //     return `${tabela.id.tabelaId.toString()} - ${tabela.descricao.trim()}`;
  //   }
  // }

  addListaTabela() {
    const dialogRef: MatDialogRef<any> = this.dialog.open(PrecoTablePopupComponent, {
      width: this.layout.isMobile ? '100vw' : '1024px',
      maxWidth: '100vw',
      height: this.layout.isMobile ? '100dvh' : undefined,
      maxHeight: '100dvh',
      disableClose: true,
      data: { title: 'Nova Tabela de preços', payload: {} }
    })
    dialogRef.afterClosed()
      .subscribe(res => {
        if (!res) {
          return;
        }
        this.loader.open();
        this.precoService.saveOrUpdate(res)
          .subscribe(data => {
            this.loader.close();
            this.snack.open('Tabela de preços Salvo com sucesso!', 'OK', { duration: 5500 });
            this.listaPreco = data;
            this.doctoCForm.patchValue({ ListaTabela: data });
          }, (err: HttpErrorResponse) => {
            this.loader.close();
            this.snack.open('Erro ao salvar a Tabela de preços!', 'ERRO', { duration: 5500 });
          })
      })

  }


  // ---------- Finaliza definições de type ahead ----------//


  // carta de correcao//

  downloadPdf(row: FatDoctoCCce) {
    this.fatDoctoCService.pdfCarta(row.id).subscribe((response) => {
      const file = new Blob([response], { type: 'application/pdf' });
      const name = row.uuid + '-CC';
      FileSaver.saveAs(file, name + '.pdf');
      // this.deleteLog();
      // this.loader.close();
    }, err => {
      // this.loader.close();
      this.progressLoader.close();
      const response = JSON.parse(new TextDecoder().decode(err.error));
      this.confirmService.confirm({
        title: 'ERRO AO BAIXAR PDF DA CARTA DE CORRECAO',
        message: response.status, error: true
      })
    });
  }

  popUpCC(row: FatDoctoCCce) {

  }

  deleteCC(row: FatDoctoCCce) {

  }



  // fim carta de correcao//

  /**
   * Acções botões inferior
   */
  print(form?: number) {
    // imprime DFE se indefinido.
    // if (form === undefined) {

    // }
    switch (form) {
      case 1: {
        console.log('PRINT FORM 1');
        this.loadForm(1);
        this.loader.close();
        break;
      }
      case 2: {
        console.log('PRINT FORM 2');
        this.loadForm(2);
        this.loader.close();
        break;
      }
      case 3: {
        console.log('PRINT FORM 3');
        this.loadForm(3);
        this.loader.close();
        break;
      }
      default: {
        console.log('PRINT FORM DFE');
        this.loadForm(0);
        this.loader.close();
        break;
      }
    }


  }

  private loadForm(formId: number) {
    this.loader.close();
    this.loader.open('Gerando PDF ! Aguarde...');
    // this.fatDoctoCService.printForm(this.lcto?.controle, formId, true).subscribe((response) => {
    //   const file = new Blob([response], { type: 'application/pdf' });
    //   const name = formId === 0 ? this.lcto?.nfechaveacesso : this.lcto?.controle + '-form' + formId;
    //   FileSaver.saveAs(file, name + '.pdf');
    //   this.loader.close();
    //   this.openLcto(this.lcto?.controle);
    // }, err => {
    //   this.loader.close();
    //   const response = JSON.parse(new TextDecoder().decode(err.error));
    //   this.snack.open(`ERRO:${response.status}!`, 'ERRO', { duration: 5500 });
    //   this.confirmService.confirm({
    //     title: 'ERRO AO BAIXAR PDF',
    //     message: response.status, error: true
    //   }).subscribe(doc => {
    //     console.log(doc);
    //   });
    // });

    this.fatDoctoCService.printForm(this.lcto?.controle, formId, true).subscribe((response) => {
      this.loader.close();
      const file = new Blob([response], { type: 'application/pdf' });
      // No DF-e (formId 0) o arquivo leva a chave de acesso: a da NF-e tem 44 posições e a da
      // NFS-e, 50 — por isso a chave da NFS-e vem do bloco nfse, não de nfechaveacesso.
      const chaveDfe = this.isNfseDocto
        ? (this.doctoCForm?.get('nfse.nfseChaveacesso')?.value ?? this.lcto?.nfse?.nfseChaveacesso)
        : this.lcto?.nfechaveacesso;
      const name = formId === 0
        ? (chaveDfe || this.lcto?.controle + '-dfe')
        : this.lcto?.controle + '-form' + formId;
      FileSaver.saveAs(file, name + '.pdf');
      this.openLcto(this.lcto?.controle);
    }, err => {
      this.loader.close();
      const response = err.error;
      this.snack.open(`ERRO:${response}!`, 'ERRO', { duration: 5500 });
      console.log(`response: >>>>>>>> ${JSON.stringify(response)}`);

      this.confirmService.confirm({
        title: 'ERRO AO BAIXAR PDF',
        message: response, error: true
      }).subscribe(doc => {
        console.log(doc);
      });
    });

  }

  /** Regime especial de tributação do ISSQN (NFS-e — campo regEspTrib). */
  readonly regimesEspeciaisTributacao = [
    { value: 'NENHUM', label: '0 - Nenhum' },
    { value: 'MICROEMPRESA_MUNICIPAL', label: '1 - Microempresa Municipal' },
    { value: 'ESTIMATIVA', label: '2 - Estimativa' },
    { value: 'SOCIEDADE_PROFISSIONAIS', label: '3 - Sociedade de Profissionais' },
    { value: 'COOPERATIVA', label: '4 - Cooperativa' },
    { value: 'MEI', label: '5 - Microempreendedor Individual (MEI)' },
    { value: 'ME_EPP', label: '6 - Microempresa ou Empresa de Pequeno Porte (ME/EPP)' },
  ];

  /**
   * Modelo do documento a partir da série do lançamento (fat_serie.seriemodelo):
   * 55=NF-e, 65=NFC-e, 57=CT-e, 58=MDF-e, 99=NFS-e.
   */
  get modeloDocto(): string {
    return String(this.doctoCForm?.value?.modelo
      ?? this.doctoCForm?.value?.serie?.serieModelo
      ?? this.lcto?.serie?.serieModelo ?? '').trim();
  }

  /** Verdadeiro quando o documento é NFS-e (série modelo 99). */
  get isNfseDocto(): boolean {
    return this.modeloDocto === '99';
  }

  /** Modelos emitidos por esta tela — habilita os botões de prévia/autorização. */
  private isModeloComEmissao(serieModelo: string): boolean {
    const modelo = String(serieModelo ?? '').trim();
    return modelo === '55' || modelo === '65' || modelo === '99';
  }

  /** Rótulo do documento eletrônico conforme o modelo da série. */
  get rotuloDfe(): string {
    return this.isNfseDocto ? 'NFS-e' : 'DF-e';
  }

  /** Situação da NFS-e em texto legível (o backend serializa o enum como STRING). */
  get nfseSituacaoDescricao(): string {
    const situacao = this.doctoCForm?.get('nfse.nfseSituacao')?.value
      ?? this.lcto?.nfse?.nfseSituacao;
    return situacao ? (NFSE_SITUACAO_DESCRICAO[situacao] ?? situacao) : '';
  }

  /**
   * Documento já transmitido (autorizado, cancelado ou denegado): o número não pode mais mudar.
   * Mesmos códigos que o backend recusa para alterar/excluir (FatDoctoCCommandService.deleteCascade).
   */
  get numeroDoctoBloqueado(): boolean {
    const status = Number(this.lcto?.statuslcto ?? 0);
    if ([100, 150, 101, 151, 132, 135, 136, 110, 204, 205, 301, 302, 303].indexOf(status) >= 0) {
      return true;
    }
    // A NFS-e guarda a situação no próprio grupo nfse, não no cStat.
    const nfse = this.doctoCForm?.get('nfse.nfseSituacao')?.value ?? this.lcto?.nfse?.nfseSituacao;
    return ['PROCESSANDO', 'AUTORIZADA', 'CANCELADA'].indexOf(nfse) >= 0;
  }

  get numeroDoctoTooltip(): string {
    if (!this.numeroDoctoBloqueado) {
      return 'Número sequencial da série. Deixe em branco para gerar automaticamente ao salvar';
    }
    // 204 = Duplicidade de NF-e: a nota já existe na SEFAZ com esta chave. Trocar o número geraria
    // outra nota; a consulta traz o protocolo e atualiza a situação.
    if (Number(this.lcto?.statuslcto ?? 0) === 204) {
      return 'Rejeição 204 (Duplicidade de NF-e): esta nota já está registrada na SEFAZ. '
        + 'Não altere o número — consulte a NF-e para atualizar a situação';
    }
    return 'Documento transmitido à SEFAZ — o número não pode mais ser alterado';
  }

  /** Baixa o XML do DPS (prévia da NFS-e), sem transmitir à SEFIN. */
  previaNfse() {
    if (!this.lcto?.controle) {
      return;
    }
    this.loader.open();
    this.fatDoctoCService.previewDpsNfse(this.lcto.controle).subscribe(xml => {
      this.loader.close();
      const file = new Blob([xml], { type: 'application/xml' });
      FileSaver.saveAs(file, `${this.lcto?.controle}-dps.xml`);
    }, err => {
      this.loader.close();
      this.confirmService.confirm({
        title: 'ERRO AO GERAR PRÉVIA DA NFS-e',
        message: err?.error?.status ?? err?.error ?? 'Falha ao montar o DPS', error: true
      });
    });
  }

  /** Consulta a NFS-e na SEFIN pela chave gravada e reconcilia a situação no documento. */
  consultaNfse() {
    if (!this.lcto?.controle) {
      return;
    }
    this.loader.open();
    this.fatDoctoCService.consultarNfse(this.lcto.controle).subscribe(val => {
      this.loader.close();
      this.buildDoctoCForm(val);
      this.confirmService.confirm({
        title: 'CONSULTA NFS-e',
        message: 'Situação da NFS-e atualizada com a SEFIN.', error: false, disableCancel: true
      });
    }, err => {
      this.loader.close();
      this.confirmService.confirm({
        title: 'ERRO AO CONSULTAR NFS-e',
        message: err?.error?.status ?? 'Falha na consulta da NFS-e', error: true
      });
    });
  }

  /**
   * Antes de transmitir, confere se a série e a transação apontam o mesmo documento.
   *
   * A emissão segue o MODELO DA SÉRIE (99 = NFS-e), mas formulário e numeração vêm da diretiva
   * (d121) — divergência entre os dois é erro de cadastro da transação e sai como documento
   * impresso no formulário errado. Avisa e segue: quem decide é a série, como no desktop.
   */
  private avisarDivergenciaSerieTransacao(): Observable<boolean> {
    const modelo = this.modeloDocto;
    const transacaoId = this.fatTransacao?.id ?? this.doctoCForm?.value?.fatTransacao?.id;
    if (!modelo || transacaoId === undefined || transacaoId === null) {
      return of(true);
    }
    return this.fatTransacaoService.getDiretiva(transacaoId).pipe(
      switchMap((diretiva) => {
        const d121 = Number(diretiva?.d121TipoDoLancamento ?? 0);
        // Mesmo de-para do TipoDfeLancamento no backend: 1 NF-e/NFC-e, 5 CT-e, 6 MDF-e, 7 NFS-e.
        const tipoPelaSerie = modelo === '99' ? 7
          : (modelo === '55' || modelo === '65') ? 1
            : modelo === '57' ? 5
              : modelo === '58' ? 6 : 0;
        if (!tipoPelaSerie || !d121 || tipoPelaSerie === d121) {
          return of(true);
        }
        return this.confirmService.confirm({
          title: 'Série e transação apontam documentos diferentes',
          message: `A série do lançamento é do modelo ${modelo} (${this.rotuloDfe}) e a transação `
            + `está configurada como tipo ${d121} na diretiva 121. `
            + 'A emissão vai seguir o modelo da série; revise a diretiva da transação, '
            + 'que é quem define o formulário do documento.',
          error: true,
          icon: 'warning',
          okText: 'Autorizar mesmo assim',
          cancelText: 'Revisar transação'
        }).pipe(map((confirmado) => !!confirmado));
      }),
      // Falha ao ler a diretiva não pode impedir a emissão: sem ela, apenas não há o que conferir.
      catchError(() => of(true))
    );
  }

  autoriza() {
    this.avisarDivergenciaSerieTransacao().subscribe((prosseguir) => {
      if (prosseguir) {
        this.autorizaDfe();
      }
    });
  }

  private autorizaDfe() {
    const obs = new BehaviorSubject<Log>({} as Log);
    this.progressLoader.open(obs);
    // this.loader.open("Autorizando DF-e ! Aguarde...");
    timer(1, 1500).pipe(
      switchMap(() => this.fatDoctoCService.getLog(this.lcto?.uuid)),
      retry(),
      share(),
      takeUntil(this.stopPolling)
    ).subscribe(valor => {


      console.log(valor);
      if (this.max === valor.max && this.workDone === valor.workDone) {
        this.it = this.it + 1;
      } else {
        this.it = 0;
      }
      this.max = valor.max;
      this.workDone = valor.workDone;
      if ((valor.workDone !== null && valor.workDone !== undefined
        && valor.max != null && valor.max !== undefined
        && valor.workDone >= valor.max) || this.it === this.maxRetry) {
        this.stopPolling.next();
        this.initLogDetails();
      }
      obs.next(valor);
      // this.loader.close();
    }, err => {
      this.loader.close();
      const response = JSON.parse(new TextDecoder().decode(err.error));
      this.snack.open(`ERRO:${response.status}!`, 'ERRO', { duration: 5500 });
      this.confirmService.confirm({
        title: 'ERRO AO AUTORIZAR',
        message: err.error.status, error: true
      })
    });
    this.save(true).subscribe(doc => {
      if (doc !== null) {
        // Despacha por modelo: NFS-e (99) via DPS server-side; demais (55/65) via NF-e.
        const modeloAut = String(this.doctoCForm?.value?.modelo ?? this.lcto?.serie?.serieModelo ?? '');
        const isNfse = modeloAut === '99';
        const autorizaObs = isNfse
          ? this.fatDoctoCService.autorizaNfse(doc.controle)
          : this.fatDoctoCService.autorizaNfe(doc.controle);
        autorizaObs.subscribe(val => {
          console.log(val);
          this.loader.close();
          this.openProgressLoader(obs);
          this.buildDoctoCForm(val);
          // NF-e/NFC-e imprimem o DANFE e a NFS-e o DANFSe — mesmo endpoint (formId 0).
          this.print(0);
        }, err => {
          this.snack.open(`ERRO:${err.error.status}!`, 'ERRO', { duration: 5500 });
          this.loader.close();
          this.confirmService.confirm({
            title: 'ERRO AO AUTORIZAR',
            message: err.error.status, error: true
          })
        });
      }
    });

    // this.loader.close();


  }



  cancela() {
    const obs = new BehaviorSubject<Log>(null);
    this.confirmService.confirm({
      title: 'Cancelamento da nota : ' + this.lcto?.nfechaveacesso,
      message: 'Digite o motivo do Cancelamento:', options: null, containsText: true
    })
      .subscribe(val => {
        if (val) {
          console.log(val);
          if (val.length < 15) {
            this.confirmService.confirm({
              title: 'ERRO AO CANCELAR NF',
              message: 'CANCELAMENTO NÃO EFETIVADO, MOTIVO DEVE TER AO MENOS 15 CARACTERES', error: true
            })
          } else {
            this.confirmService.confirm({
              title: 'CONFIRME O MOTIVO DO CANCELAMENTO:',
              message: val
            }).subscribe(confirm => {
              if (confirm) {
                this.loader.open();
                const modeloCanc = String(this.doctoCForm?.value?.modelo ?? this.lcto?.serie?.serieModelo ?? '');
                const cancelarObs = modeloCanc === '99'
                  ? this.fatDoctoCService.cancelarNfse(this.lcto?.controle, val)
                  : this.fatDoctoCService.cancelar(this.lcto?.controle, val);
                cancelarObs.subscribe(rs => {
                  this.loader.close();
                  this.deleteLog();
                  if (rs) {
                    this.confirmService.confirm({
                      title: 'CANCELAR',
                      message: 'OK, Nota Cancelada com Sucesso!', error: false, disableCancel: true
                    }).subscribe(e => {
                      this.refreshAfterStatusChange();
                    });
                  }
                }, err => {
                  this.loader.close();
                  this.confirmService.confirm({
                    title: 'ERRO AO CANCELAR NFE',
                    message: err.error.status, error: true
                  })
                })
              } else {
                this.confirmService.confirm({
                  title: 'CANCELAR NF-e',
                  message: 'CANCELAMENTO NÃO EFETIVADO', error: true
                })
              }
            })
          }
        } else {
          this.confirmService.confirm({
            title: 'ERRO AO CANCELAR NF',
            message: 'CANCELAMENTO NÃO EFETIVADO', error: true
          })
        }
      });
  }

  previa() {
    // NFS-e usa o MESMO caminho da NF-e: /previa devolve o PDF (DANFSe montado do DPS).
    // O XML do DPS continua disponível à parte, em previaNfse().
    const obs = new BehaviorSubject<Log>(null);
    this.progressLoader.open(obs);
    timer(1, 1500).pipe(
      switchMap(() => this.fatDoctoCService.getLog(this.lcto?.uuid)),
      retry(),
      share(),
      takeUntil(this.stopPolling)
    ).subscribe(valor => {
      console.log(valor);
      if (this.max === valor.max && this.workDone === valor.workDone) {
        this.it = this.it + 1;
      } else {
        this.it = 0;
      }
      this.max = valor.max;
      this.workDone = valor.workDone;
      if ((valor.workDone !== null && valor.workDone !== undefined
        && valor.max != null && valor.max !== undefined
        && valor.workDone >= valor.max) || this.it === this.maxRetry) {
        this.stopPolling.next();
        this.initLogDetails();
      }
      obs.next(valor);
    }, err => {
      // this.loader.close();
      this.snack.open(`ERRO:${err.error.status}!`, 'ERRO', { duration: 5500 });
      this.confirmService.confirm({
        icon: 'warning',
        title: 'ERRO AO CARREGAR PREVIA',
        message: err.error.status, error: true
      })
    });
    this.save(true).subscribe(doc => {
      if (doc !== null) {
        this.fatDoctoCService.previaWithResponse(doc.controle).subscribe((response) => {
          const file = new Blob([response.body || new ArrayBuffer(0)], { type: 'application/pdf' });
          const name = this.lcto?.controle + (this.isNfseDocto ? '-PREVIA-NFSE' : '-PREVIA-NF');
          FileSaver.saveAs(file, name + '.pdf');
          this.showPreviewWarning(response.headers.get('X-Preview-Warning'));
          this.deleteLog();
          this.progressLoader.close();
          // this.loader.close();
        }, err => {
          // this.loader.close();
          this.progressLoader.close();
          const message = extractBackendErrorMessage(err);
          this.snack.open(`ERRO:${message}!`, 'ERRO', { duration: 5500 });
          this.confirmService.confirm({
            title: 'ERRO AO BAIXAR PDF DA PREVIA',
            message,
            error: true
          })
        });
      }
    })

  }

  private showPreviewWarning(headerWarning: string | null): void {
    if (!headerWarning) {
      return;
    }
    this.confirmService.confirm({
      title: 'ATENCAO NA PREVIA',
      message: headerWarning,
      error: false
    });
  }

  private initLogDetails() {
    this.it = 0;
    this.workDone = null;
    this.max = null;
  }

  consultarNF() {
    const obs = new BehaviorSubject<Log>(null);
    this.openProgressLoader(obs);
    timer(1, 1500).pipe(
      switchMap(() => this.fatDoctoCService.getLog(this.lcto?.uuid)),
      retry(),
      share(),
      takeUntil(this.stopPolling)
    ).subscribe(valor => {
      if (this.max === valor.max && this.workDone === valor.workDone) {
        this.it = this.it + 1;
      } else {
        this.it = 0;
      }
      this.max = valor.max;
      this.workDone = valor.workDone;
      if ((valor.workDone !== null && valor.workDone !== undefined
        && valor.max != null && valor.max !== undefined
        && valor.workDone >= valor.max) || this.it === this.maxRetry) {
        this.stopPolling.next();
        this.initLogDetails();
      }
      obs.next(valor);
    }, err => {
      // this.loader.close();
      this.snack.open(`ERRO:${err.error.status}!`, 'ERRO', { duration: 5500 });
      this.confirmService.confirm({
        title: 'ERRO AO CONSULTAR NOTA',
        message: err.error.status, error: true
      })
    });
    this.fatDoctoCService.consultar(this.lcto?.controle).subscribe((response) => {
      this.snack.open(`CONSULTA:${response?.status}!`, 'CONSULTA', { duration: 5500 });
      this.confirmService.confirm({
        title: 'CONSULTA NF-e EM' + `[${response?.ambiente ?? 'PRODUÇÃO'}]`,
        message: (response?.status ?? '') + ' - ' + response?.motivo ?? '', error: false,
        disableCancel: true
      })
      this.deleteLog();
      // this.loader.close();
    }, err => {
      // this.loader.close();
      this.progressLoader.close();
      this.snack.open(`ERRO:${err.error.status}!`, 'ERRO', { duration: 5500 });
      this.confirmService.confirm({
        title: 'ERRO AO CONSULTAR NOTA',
        message: err.error.status, error: true
      })
    });

  }

  enviaEmail() {
    const obs = new BehaviorSubject<Log>(null);
    this.openProgressLoader(obs);
    this.confirmService.confirm({
      title: 'Enviar e-mail para  ',
      message: 'Digite o e-mail abaixo.Para inserir mais de um e-mail, separe-os com ponto e vírgula ; ', containsText: true, selectedText: this.lcto?.cadCadastro.email
    }).subscribe(val => {
      if (val) {
        this.loader.open('Enviando e-mail ! Aguarde...');
        this.fatDoctoCService.enviarEmail(this.lcto?.controle, val).subscribe((response) => {
          this.confirmService.confirm({
            title: `ENVIO DA ${this.rotuloDfe} `,
            icon: 'check_circle',
            message: response.sucess, error: false,
            disableCancel: true
          });
          this.deleteLog();
          this.progressLoader.close();
          this.loader.close();
        }, err => {
          this.progressLoader.close();
          this.snack.open(`ERRO:${err.error.status}!`, 'ERRO', { duration: 5500 });
          this.confirmService.confirm({
            title: 'ERRO AO ENVIAR EMAIL',
            icon: 'warning',
            message: err.error.status, error: true
          });
        });
      } else {
        this.progressLoader.close();
      }
    });
  }

  save(previa = false, mostrarOk = true): BehaviorSubject<FatDoctoC> {
    const result = new BehaviorSubject<FatDoctoC>(null);
    // Prévia (DF-e) não passa pela checagem de estoque; só gravação real valida.
    if (previa) {
      this.persistirLancamento(previa, mostrarOk, result);
      return result;
    }
    // Checa estoque negativo conforme diretiva d210ChecarEstoque antes de gravar.
    this.checarEstoqueNegativo().subscribe(({ bloqueia, mensagens }) => {
      if (mensagens.length > 0) {
        this.confirmService.confirm({
          title: bloqueia ? '** ATENÇÃO! ** ESTOQUE NEGATIVO, VERIFIQUE !' : 'A T E N Ç Ã O ! ESTOQUE NEGATIVO !',
          icon: 'warning',
          message: 'PRODUTO(S):\n' + mensagens.join('\n'), error: true
        });
      }
      if (bloqueia) {
        this.loader.close();
        return; // d210 = "1": bloqueia a gravação
      }
      this.persistirLancamento(previa, mostrarOk, result);
    });
    return result;
  }

  private persistirLancamento(previa: boolean, mostrarOk: boolean, result: BehaviorSubject<FatDoctoC>): void {
    // const obs = new BehaviorSubject<Log>({} as Log);
    // this.loader.close();
    // this.loader.open("Gerando Prévia dd DF-e");
    // this.openProgressLoader(obs);
    // this.isSaving$.next(true);
    // this.itemForm.patchValue({ fatListaPrecoTabelaId: this.itemForm['fatListaPrecoTabela'].value?.id?.tabelaId });

    // this.doctoCForm.patchValue({cadastroVendedorId: this.doctoCForm["cadastroVendedorId"],});

    // this.doctoCForm.patchValue({ items: this.doctoIs$.value });
    this.fatDoctoCService.saveOrUpdate(this.doctoCForm.value).subscribe(val => {
      this.reloadLctoDetails(val);
      this.buildDoctoCForm(val);
      console.log(val);
      this.deleteLog();
      if (!previa) {
        this.loader.close()
        if (mostrarOk) {
          // this.snack.open(`SALVO COM SUCESSO!`, 'OK', { duration: 5500 });
          this.confirmService.confirm({
            title: 'S U C E S S O !',
            icon: 'check_circle',
            message: 'OK, LANÇAMENTO SALVO COM SUCESSO!', error: false
          });
        }
      }
      this.loader.close();
      this.snack.open('S U C E S S O !', 'LANÇAMENTO SALVO COM SUCESSO', { duration: 2000 });
      this.isEditableDoctI = {};
      result.next(val);
      this.vincularAoFunil(val);
      // this.isSaving$.next(false);
      this.loader.close();
    }, err => {
      this.loader.close();
      this.deleteLog();
      result.error(err);
      // this.isSaving$.next(false);
      this.snack.open(`** ATENÇÃO! **:${err.error.status}!`, 'ERRO AO SALVAR LANÇAMENTO', { duration: 5500 });
      this.confirmService.confirm({
        title: '** ATENÇÃO! ** ! ERRO AO SALVAR, VERIFIQUE',
        icon: 'warning',
        message: err.error.status, error: true
      })
    });
    this.loader.close();
  }

  /**
   * Checa estoque negativo antes de gravar, conforme a diretiva d210ChecarEstoque
   * ("0" = apenas avisa; "1" = avisa e bloqueia).
   *
   * Aplica a "opção 1": para documentos de Saída já gravados (controle > 0) estorna a
   * quantidade já movimentada por este mesmo documento (itens persistidos), evitando a
   * dupla contagem que acusaria "ESTOQUE NEGATIVO" indevido ao re-salvar — pois o saldo
   * do produto já reflete a saída anterior. Documento novo não estorna nada.
   *
   * Item sem informação de saldo carregada é ignorado (não bloqueia por falta de dado).
   */
  private checarEstoqueNegativo(): Observable<{ bloqueia: boolean; mensagens: string[] }> {
    const semChecagem = { bloqueia: false, mensagens: [] as string[] };
    const docto = this.doctoCForm.value;
    const transacaoId = this.fatTransacao?.id ?? docto?.fatTransacao?.id;
    if (transacaoId === undefined || transacaoId === null) {
      return of(semChecagem);
    }
    return this.fatTransacaoService.getDiretiva(transacaoId).pipe(
      switchMap((diretiva) => {
        const d210 = `${diretiva?.d210ChecarEstoque ?? ''}`;
        if (d210 !== '0' && d210 !== '1') {
          return of(semChecagem);
        }
        const isSaida = `${docto?.serieNatureza ?? ''}`.trim().toLowerCase() === 'saida';
        const controle = Number(docto?.controle ?? 0);
        // "opção 1": mapa produtoId -> qtde já movimentada (só p/ Saída já gravada).
        const qtdeJaMovimentada$: Observable<Map<number, number>> =
          (isSaida && controle > 0)
            ? this.fatDoctoCService.getPageItem(controle, 1, 100000).pipe(
              map((page) => {
                const mapa = new Map<number, number>();
                (page?.content ?? []).forEach((it) => {
                  const pid = it?.id?.fatProduto?.id;
                  if (pid !== undefined && pid !== null) {
                    mapa.set(pid, (mapa.get(pid) ?? 0) + (Number(it?.qtde) || 0));
                  }
                });
                return mapa;
              }),
              catchError(() => of(new Map<number, number>()))
            )
            : of(new Map<number, number>());

        return qtdeJaMovimentada$.pipe(
          map((estorno) => {
            const mensagens: string[] = [];
            (this.doctoIs ?? []).forEach((item) => {
              const produto = item?.id?.fatProduto;
              if (!produto) {
                return;
              }
              const rawSaldo = produto?.saldo ?? produto?.fatProdutoSaldo?.saldo;
              // sem info de saldo -> não bloqueia
              if (rawSaldo === undefined || rawSaldo === null) {
                return;
              }
              const pid = produto?.id;
              const saldoLivre = Number(rawSaldo) + (pid != null ? (estorno.get(pid) ?? 0) : 0);
              const qtde = Number(item?.qtde ?? 0);
              if (saldoLivre - qtde < 0) {
                const cod = `${produto?.codigo ?? ''}`.padStart(6, '0');
                mensagens.push(
                  `${cod} - ${(produto?.descricao ?? '').trim()}  ATUAL: [${saldoLivre}]  PREVISÃO: [${saldoLivre - qtde}]`
                );
              }
            });
            return { bloqueia: d210 === '1' && mensagens.length > 0, mensagens };
          })
        );
      }),
      catchError(() => of(semChecagem))
    );
  }

  fixaPesoBruto() {
    this.doctoCForm.controls['fixaPesoBruto'].patchValue(true);
  }

  fixaPesoLiquido() {
    this.doctoCForm.controls['fixaPesoLiquido'].patchValue(true);
  }

  fixaVolumes() {
    this.doctoCForm.controls['fixaVolumes'].patchValue(true);
  }

  changeDescPerc() {
    const descPerc = this.doctoCForm.controls['descontodoctoPerc'].value;
    const totalProdutos = this.doctoCForm.controls['totalprodutos'].value;
    if (descPerc === 0) {
      this.doctoCForm.controls['descontodoctoPerc'].patchValue(0);
      this.doctoCForm.controls['descontodoctoValor'].patchValue(0);
    } else if (descPerc <= 100) {
      const descValor = totalProdutos * (descPerc / 100);
      this.doctoCForm.controls['descontodoctoValor'].patchValue(descValor);
    } else {
      this.confirmService.confirm({
        title: 'A T E N Ç Ã O !',
        message: 'Valor desconto: ' + descPerc + ' maior que 100% , VERIFIQUE!', error: true
      });
      this.doctoCForm.controls['descontodoctoValor'].patchValue(0);
      this.doctoCForm.controls['descontodoctoPerc'].patchValue(0);
      return;
    }
    this.recalcTotal();
  }


  changeDescValor() {
    const descValor = this.doctoCForm.controls['descontodoctoValor'].value;
    const totalProdutos = this.doctoCForm.controls['totalprodutos'].value;
    this.doctoCForm.controls['descontodoctoPerc'].patchValue(0);
    if (descValor === 0) {
      this.doctoCForm.controls['descontodoctoPerc'].patchValue(0);
    } else if (descValor <= totalProdutos) {
      const result = ((totalProdutos - (totalProdutos - descValor)) * 100) / totalProdutos;
      this.doctoCForm.controls['descontodoctoPerc'].patchValue(result);
    } else {
      this.confirmService.confirm({
        title: 'A T E N Ç Ã O !',
        message: 'Valor desconto: ' + descValor + ' maior que o Total dos produtos:' + totalProdutos + 'VERIFIQUE!', error: true
      });
      this.doctoCForm.controls['descontodoctoValor'].patchValue(0);
      return;
    }
    this.recalcTotal();
    //     fatDoctoCQueryService.recalcTotais(getFatDoctoCBean(), itemListController.getMasterData());
  }

  recalcTotal() {

    const totalliquidoprodutos = this.doctoCForm.controls['totalliquidoprodutos']?.value || 0;
    const freteValor = this.doctoCForm.controls['freteValor']?.value || 0;
    const despesaValor = this.doctoCForm.controls['despesaValor']?.value || 0;
    const ipiValor = this.doctoCForm.controls['ipiValor']?.value || 0;
    const icmssubstValor = this.doctoCForm.controls['icmssubstValor']?.value || 0;
    const seguroValor = this.doctoCForm.controls['seguroValor']?.value || 0;
    const icmsDesonValor = this.doctoCForm.controls['icmsDesonValor']?.value || 0;
    const descontodoctoValor = this.doctoCForm.controls['descontodoctoValor']?.value || 0;

    this.doctoCForm.controls['valortotalDocto'].patchValue(totalliquidoprodutos + freteValor
      + despesaValor + ipiValor + icmssubstValor + seguroValor - icmsDesonValor - descontodoctoValor);
  }


  submit() {
    if (this.doctoCForm.valid) {
      console.log('form submitted');
      // this.dialogRef.close(this.itemForm.value)
    } else {
      this.validateAllFormFields(this.doctoCForm); // {7}
    }
  }


  // ---------- Finaliza ações inferior ----------//

  openParcelas(data: any = {}) {
    if (this.verifyIsLctoNotSaved(data.value)) {
      return;
    }
    const title = `PARCELAS CTRL: [ ${data.value.controle.toString().padStart(10, '0')} ] DESTINATÁRIO:${data.value.nome} `;
    const dialogFinanc: MatDialogRef<any> = this.dialog.open(LancamentoParcelasComponent, {
      width: this.layout.isMobile ? '100vw' : '90vw',
      maxWidth: this.layout.isMobile ? '100vw' : '90vw',
      height: this.layout.isMobile ? '100dvh' : '85vh',
      maxHeight: '100dvh',
      disableClose: true,
      panelClass: ['custom-dialog-class', 'parcelas-dialog-panel'],
      data: { title: title, payload: data }
    })
    dialogFinanc.afterClosed()
      .subscribe(() => {
        this.openLcto(this.lcto?.controle);
      })
  }



  /** UTILS */
  private deleteLog() {
    this.fatDoctoCService.deleteLog(this.lcto?.uuid).subscribe((log) => {
      this.progressLoader.close();
    });
  }

  private openProgressLoader(obs: BehaviorSubject<Log>) {
    this.progressLoader.open(obs, 'Processando, aguarde...');
    timer(1, 1500).pipe(
      switchMap(() => this.fatDoctoCService.getLog(this.lcto?.uuid)),
      retry(),
      share(),
      takeUntil(this.stopPolling)
    ).subscribe(valor => {
      if (this.max === valor.max && this.workDone === valor.workDone) {
        this.it = this.it + 1;
      } else {
        this.it = 0;
      }
      this.max = valor.max;
      this.workDone = valor.workDone;
      if ((valor.workDone !== null && valor.workDone !== undefined
        && valor.max != null && valor.max !== undefined
        && valor.workDone >= valor.max) || this.it === this.maxRetry) {
        this.stopPolling.next();
        this.initLogDetails();
      }
      obs.next(valor);
    }, err => {
      this.confirmService.confirm({
        title: 'ERRO AO EXECUTAR OPERAÇÃO',
        message: err.error.status, error: true
      });
    });
  }

  validateAllFormFields(formGroup: FormGroup) {         // {1}
    Object.keys(formGroup.controls).forEach(field => {  // {2}
      const control = formGroup.get(field);             // {3}
      if (control instanceof FormControl) {             // {4}
        console.log(field + ' - ' + control.valid);
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        // {5}
        this.validateAllFormFields(control);            // {6}
      }
    });
  }

  isFieldValid(field: string) {
    return !this.doctoCForm.get(field).valid && this.doctoCForm.get(field).touched;
  }

  setSelectedTabIndex(event: MatTabGroup) {
    this.selectedTabIndex = event.selectedIndex;
    if (event._tabs.toArray()[event.selectedIndex].textLabel.indexOf('Parcelas') > -1) {

    } else if (event._tabs.toArray()[event.selectedIndex].textLabel.indexOf('Endere') > -1) {
    } else if (event._tabs.toArray()[event.selectedIndex].textLabel.indexOf('Referenciados') > -1) {

    } else if (event._tabs.toArray()[event.selectedIndex].textLabel.indexOf('correção') > -1) {

    } else if (event._tabs.toArray()[event.selectedIndex].textLabel.indexOf('Itens') > -1) {
      this.reloadPageItem();
      if (this.lcto?.controle === 0) {
        this.save(false, false);
      }
    }
  }

  close() {
    if (this.currentDialogRef) {
      this.currentDialogRef.close();
      return;
    }

    history.back();
    // this.confirmService.confirm({ message: `Deseja realmente fechar? Poderá haver perda de dados.` })
    //   .subscribe(res => {
    //     if (res) {
    //       if (this.openModal === true) {
    //         this.dialog.openDialogs.map(di => di.close());
    //       } else {
    //         history.back();
    //         // this.router.navigate(['/fat_movto/lancamentos']);
    //       }
    //     }
    //   });
  }

  private refreshAfterStatusChange() {
    if (this.currentDialogRef && this.lcto?.controle) {
      this.openLcto(this.lcto.controle);
      return;
    }

    this.router.navigate(['/lcto_detail/' + this.lcto.controle + '/false']);
  }

  /** So da para copiar o que ja foi gravado: o Idem copia o lancamento do banco, nao o formulario. */
  get podeIdem(): boolean {
    return !!(this.lcto?.controle && this.lcto.controle > 0);
  }

  /**
   * "Idem": copia o lancamento (endpoint /idem) e abre a copia para ajustar -- mesma logica do Idem
   * da lista de lancamentos e do produto na tela de itens.
   */
  idemLcto(): void {
    if (!this.podeIdem) {
      this.snack.open('Salve o lançamento antes de copiar.', 'OK', { duration: 3000 });
      return;
    }
    const controle = this.lcto.controle;
    // A copia sai do que esta gravado; edicao pendente no formulario nao entra nela.
    const aviso = this.doctoCForm?.dirty ? ' Alterações não salvas não entram na cópia.' : '';
    this.confirmService
      .confirm({ message: `Copiar ${controle.toString().padStart(6, '0')}?${aviso}` })
      .subscribe((ok) => {
        if (!ok) {
          return;
        }
        this.loader.open();
        this.fatDoctoCService.idemFatDoctoC(controle).subscribe(
          (copia) => {
            this.loader.close();
            this.snack.open('Lançamento copiado com sucesso!', 'OK', { duration: 5500 });
            this.abrirCopia(copia);
          },
          () => {
            this.loader.close();
            this.snack.open('Erro ao copiar Lançamento!', 'ERRO', { duration: 5500 });
          }
        );
      });
  }

  /**
   * Abre a copia nesta mesma tela.
   *
   * A rota e a mesma do original (a copia herda o modelo), so muda o controle -- e nesse caso o
   * Angular reaproveita o componente sem passar pelo ngOnInit. Por isso a carga e pedida aqui.
   */
  private abrirCopia(copia: FatDoctoC): void {
    if (!copia?.controle) {
      return;
    }
    this.selectedTabIndex = 0;
    this.controle = copia.controle;
    if (this.currentDialogRef) {
      this.openLcto(copia.controle);
      return;
    }
    const base = '/' + (this.router.url.split('/')[1] || 'lcto_detail');
    this.router.navigate([base, copia.controle, 'false']).then(() => this.openLcto(copia.controle));
  }

  novoLcto() {
    if (this.currentDialogRef) {
      this.selectedTabIndex = 0;
      this.showEditOption = true;
      this.create();
      return;
    }

    const modelo =
      this.doctoCForm?.value?.modelo ??
      this.lcto?.serie?.serieModelo ??
      null;

    const modeloStr = modelo != null ? String(modelo) : '';

    if (modeloStr === '57') {
      this.router.navigate(['/cte_detail/add']);
    } else if (modeloStr === '58') {
      this.router.navigate(['/mdfe_detail/add']);
    } else {
      // Quem está numa OS continua em OS ao clicar "Novo" — senão voltaria para o lançamento comum.
      const queryParams = this.isOrdemServico ? { tipoLcto: 'ORDEM_SERVICO' } : {};
      this.router.navigate(['/lcto_detail/add'], { queryParams });
    }
  }

  // Save row
  saveDoctoI(rowIndex: string) {
    // this.loader.open(`Salvando Item ${(rowIndex + 1).toString().padStart(3, '0')} ...`);
    this.isEditableDoctI[rowIndex] = !this.isEditableDoctI[rowIndex];
    this.save(false, false);
    // this.fatDoctoCService.saveOrUpdateItem(this.doctoIForm.value).subscribe(savedItem => {
    //   console.log(savedItem);
    //   this.loader.close();
    //   this.confirmService.confirm({
    //     title: 'SUCESSO !',
    //     message: `Item ${(rowIndex + 1).toString().padStart(3, '0')} Salvo com sucesso !!`, error: true
    //   })

    //   // this.reloadPageItem();
    //   // this.fatDoctoCService.getFatDoctoCClean(this.lcto?.controle).subscribe(ctl => {
    //   //   this.buildDoctoCForm(ctl);
    //   // });
    // }, err => {
    //   this.loader.close();
    //   this.confirmService.confirm({
    //     title: 'ERRO AO SALVAR ITEM, VERIFIQUE',
    //     message: err.error.status, error: true
    //   })
    // });
  }

  openItensPopUp(data: any = {}) {
    if (this.verifyIsLctoNotSaved(data.value, false)) {
      this.save(false, false).subscribe((doc) => {
        if (doc && doc.controle) {
          this.buildDoctoCForm(doc);
          const popupForm = this.fatDoctoCUtilsService.buildDoctoCForm(this.fb, doc, this.disabled);
          this.openItensPopUp({ value: doc, form: popupForm });
        }
      });
      return;
    }

    const formParaPopup = this.fatDoctoCUtilsService.buildDoctoCForm(this.fb, data.value, this.disabled);

    const title = `LANCAMENTO - ITENS CTRL: ${data.value.controle.toString().padStart(10, '0')} DESTINATÁRIO:${data.value.nome} `;
    const dialogItems: MatDialogRef<any> = this.dialog.open(LancamentoItensComponent, {
      width: this.layout.isMobile ? '100vw' : '97vw',
      maxWidth: '100vw',
      height: this.layout.isMobile ? '100dvh' : '85vh',
      maxHeight: '100dvh',
      disableClose: true,
      panelClass: 'custom-dialog-class',
      data: { title, payload: formParaPopup },
      autoFocus: false,
      restoreFocus: false,
      // scrollStrategy: this.dialog._scrollStrategy(), // Uncomment if you want to customize scroll
    });
    dialogItems.afterClosed().subscribe((res) => {
      this.openLcto(data.value.controle);

      // verificar serie para hbilitar this.dfe
      if(data.value.serie && data.value.serie !== null && data.value.serie !== undefined) {
        this.dfe = this.isModeloComEmissao(data.value.serie.serieModelo);
      }
      if (!res) {
        return;
      }
      this.loader.open();
    });
  }

  /**
   * Publica no Mercado Livre os itens deste lançamento de remessa.
   *
   * Pede confirmação porque escreve fora do sistema: depois de publicado, desfazer é encerrar
   * anúncio no painel do Mercado Livre, não desfazer um lançamento aqui.
   */
  publicarNoMarketplace() {
    if (!this.controle) {
      this.snack.open('Salve o lançamento antes de publicar.', 'OK',
        { duration: 4000, verticalPosition: 'top' });
      return;
    }
    this.confirmService.confirm({
      title: 'Mercado Livre',
      message: 'Publicar os itens deste lançamento no Mercado Livre? '
        + 'A quantidade enviada é a remessa em aberto de cada produto.'
    }).subscribe(res => {
      if (!res) {
        return;
      }
      this.loader.open();
      this.mercadoLivreAnuncioService.publicarLancamento(this.controle).subscribe(
        lote => this.mostrarResultadoMarketplace(lote, 'publicado(s)'),
        err => this.erroMarketplace(err));
    });
  }

  /** Atualiza no Mercado Livre o preço dos itens deste lançamento. Não mexe na quantidade. */
  atualizarPrecosNoMarketplace() {
    if (!this.controle) {
      this.snack.open('Salve o lançamento antes de atualizar os preços.', 'OK',
        { duration: 4000, verticalPosition: 'top' });
      return;
    }
    this.confirmService.confirm({
      title: 'Mercado Livre',
      message: 'Atualizar no Mercado Livre o preço dos itens deste lançamento? '
        + 'A quantidade dos anúncios não será alterada.'
    }).subscribe(res => {
      if (!res) {
        return;
      }
      this.loader.open();
      this.mercadoLivreAnuncioService.atualizarPrecosLancamento(this.controle).subscribe(
        lote => this.mostrarResultadoMarketplace(lote, 'atualizado(s)'),
        err => this.erroMarketplace(err));
    });
  }

  /**
   * Mostra o que deu certo e o que não deu.
   *
   * O lote responde 200 mesmo com falhas — cada item traz o próprio motivo, e é isso que permite
   * dizer "8 de 10" em vez de um erro único que esconde os que funcionaram.
   */
  private mostrarResultadoMarketplace(lote: LotePublicacao, verbo: string) {
    this.loader.close();
    const resultados = lote?.resultados || [];
    const ok = resultados.filter(r => r.sucesso).length;
    const falhas = resultados.filter(r => !r.sucesso);

    if (!falhas.length) {
      this.snack.open(`${ok} item(ns) ${verbo} no Mercado Livre.`, 'OK',
        { duration: 6000, verticalPosition: 'top' });
      return;
    }
    const detalhe = falhas.map(f => `• ${f.descricao || f.produtoId}: ${f.mensagem}`).join('\n');
    this.confirmService.confirm({
      title: `${ok} ${verbo}, ${falhas.length} com pendência`,
      message: detalhe,
      error: true
    });
  }

  private erroMarketplace(err: any) {
    this.loader.close();
    this.confirmService.confirm({
      title: 'Erro',
      message: err?.error?.message || 'Não foi possível falar com o Mercado Livre.',
      error: true
    });
  }

  openTotaisPopUp(data: any = {}) {
    if (this.verifyIsLctoNotSaved(data.value)) {
      return;
    }
    const title = 'Totais/Impostos/Dados adicionais';
    const dialogRef: MatDialogRef<any> = this.dialog.open(LancamentoTotaisComponent, {
      width: this.layout.isMobile ? '100vw' : '98%',
      maxWidth: '100vw',
      height: this.layout.isMobile ? '100dvh' : '90vh',
      maxHeight: '100dvh',
      disableClose: true,
      data: { title: title, payload: data }
    })
    dialogRef.afterClosed()
      .subscribe(() => {
        this.openLcto(this.lcto?.controle);
      })
  }

  openTranspVolumes(data: any = {}) {
    if (this.verifyIsLctoNotSaved(data.value)) {
      return;
    }
    const title = 'Transportador/Volumes';
    const dialogRef: MatDialogRef<any> = this.dialog.open(LancamentoTranspComponent, {
      width: this.layout.isMobile ? '100vw' : '98%',
      maxWidth: '100vw',
      height: this.layout.isMobile ? '100dvh' : '90vh',
      maxHeight: '100dvh',
      disableClose: true,
      data: { title: title, payload: data }
    })
    dialogRef.afterClosed()
      .subscribe(() => {
        this.openLcto(this.lcto?.controle);
      })
  }

  openDadosAdicionais(data: any = {}) { }
  openDadosNfe(data: any = {}) {
    if (this.verifyIsLctoNotSaved(data.value)) {
      return;
    }
    const title = 'XML';
    const dialogRef: MatDialogRef<any> = this.dialog.open(LancamentoNfeComponent, {
      width: this.layout.isMobile ? '100vw' : '98%',
      maxWidth: '100vw',
      height: this.layout.isMobile ? '100dvh' : '90vh',
      maxHeight: '100dvh',
      disableClose: true,
      data: { title: title, payload: data }
    })
    dialogRef.afterClosed()
      .subscribe(() => {
        this.openLcto(this.lcto?.controle);
      })
  }



  openDoctosRefPopUp(data: any = {}) {
    if (this.verifyIsLctoNotSaved(data.value)) {
      return;
    }
    const title = 'NF/NF-e/CT-e Referenciados';
    const dialogRef: MatDialogRef<any> = this.dialog.open(LancamentoReferComponent, {
      width: this.layout.isMobile ? '100vw' : '98%',
      maxWidth: '100vw',
      height: this.layout.isMobile ? '100dvh' : '90vh',
      maxHeight: '100dvh',
      disableClose: true,
      data: { title: title, payload: data }
    })
    dialogRef.afterClosed()
      .subscribe(() => {
        this.openLcto(this.lcto?.controle);
      })
  }
  openCartaCorrecao(data: any = {}) {
    if (this.verifyIsLctoNotSaved(data.value)) {
      return;
    }
    const title = 'Carta de correção';
    const dialogRef: MatDialogRef<any> = this.dialog.open(LancamentoCCComponent, {
      width: this.layout.isMobile ? '100vw' : '98%',
      maxWidth: '100vw',
      height: this.layout.isMobile ? '100dvh' : '90vh',
      maxHeight: '100dvh',
      disableClose: true,
      data: { title: title, payload: data }
    })
    dialogRef.afterClosed()
      .subscribe(() => {
        this.openLcto(this.lcto?.controle);
      })
  }

  verifyIsLctoNotSaved(data: any, showMessage = true): boolean {
    const ctrl = data.controle;
    if (ctrl === undefined || ctrl === null || ctrl === 0) {
      if (showMessage) {
        this.confirmService.confirm(
          {
            message: 'Por favor, salve o lançamento e tente novamente !!',
            error: true
          }
        );
      }
      return true;
    }
    return false;
  }

  public tabelaIdComparaison = function (option, value): boolean {
    // null-safe: a troca de cliente pode limpar a tabela quando a lista nova não tem tabela resolvida.
    return !!option?.id && !!value?.id && option.id.tabelaId === value.id.tabelaId;
  }


  openAnexoUploadListPopUp(data: any = {}) {
    if (this.verifyIsLctoNotSaved(data.value)) {
      return;
    }
    const title = 'Anexos: ';
    const dialogRef: MatDialogRef<any> = this.dialog.open(LancamentoAnexoUploadListComponent, {
      width: this.layout.isMobile ? '100vw' : '80%',
      maxWidth: '100vw',
      height: this.layout.isMobile ? '100dvh' : '90vh',
      maxHeight: '100dvh',
      disableClose: true,
      data: { title: title + '[ ' + (data.value?.controle??'') + ' - ' + (data.value?.nome??'') + ' ]', payload: data.value }
    })
    dialogRef.afterClosed()
      .subscribe(() => {
        this.openLcto(this.lcto?.controle);
      })
  }

  openAnexoUploadListPopUpCadastro(data: any = {}) {
    const cad = data.value.cadCadastro;
    if (this.verifyIsLctoNotSavedAndCadastroNaoSelecionado(data.value, true, cad)) {
      return;
    }
    const title = 'Anexo(s) Cadastrais: ';
    const dialogRef: MatDialogRef<any> = this.dialog.open(CadastroAnexoUploadListComponent, {
      width: this.layout.isMobile ? '100vw' : '80%',
      maxWidth: '100vw',
      height: this.layout.isMobile ? '100dvh' : '90vh',
      maxHeight: '100dvh',
      disableClose: true,
      data: { title: title + '[ ' + cad.codigo + ' - ' + cad.razaoSocial + ' ]', payload: cad }
    })
    dialogRef.afterClosed()
      .subscribe(res => {
        if (!res) {
          return;
        }
      })
  }

  verifyIsLctoNotSavedAndCadastroNaoSelecionado(data: any, showMessage = true, cadastro: Cadastro): boolean {
    const ctrl = data?.controle;
    const idCadastro = cadastro?.id;
    if(idCadastro === undefined || idCadastro === null || idCadastro === 0){
      if (showMessage) {
        this.confirmService.confirm(
          {
            message: 'Por favor, selecione um cadastro !!',
            error: true
          }
        );
      }
      return true;
    }
    if (ctrl === undefined || ctrl === null || ctrl === 0) {
      if (showMessage) {
        this.confirmService.confirm(
          {
            message: 'Por favor, salve o lançamento e tente novamente !!',
            error: true
          }
        );
      }
      return true;
    }
    return false;
  }





}
